export const EXPOSURE_TRACKED_METRICS_TITLE = "EXPOSURE_TRACKED_METRICS_TITLE";
export const EXPOSURE_TRACKED_METRICS_SUBTITLE =
  "EXPOSURE_TRACKED_METRICS_SUBTITLE";
export const HISTORICAL_EXPOSURE_TITLE = "HISTORICAL_EXPOSURE_TITLE";
export const REVENUE_REQUIRED_SUBTITLE = "REVENUE_REQUIRED_SUBTITLE";
export const HISTORICAL_EXPOSURE_TOOLTIP =
  "HISTORICAL_EXPOSURE_COMPARE_EXPOSURES_TOOLTIP";
export const HISTORICAL_EXPOSURE_MEASURE_COLUMN =
  "HISTORICAL_EXPOSURE_MEASURE_COLUMN";
export const HISTORICAL_EXPOSURE_UNIT_COLUMN =
  "HISTORICAL_EXPOSURE_UNIT_COLUMN";
export const HISTORICAL_EXPOSURE_PROJECTED_LABEL =
  "HISTORICAL_EXPOSURE_PROJECTED_LABEL";
export const SELECT_INDUSTRY_CLASS_MESSAGE = "SELECT_INDUSTRY_CLASS_MESSAGE";
export const CUSTOM_METRICS_TITLE = "CUSTOM_METRICS_TITLE";
export const CUSTOM_METRICS_SUBTITLE = "CUSTOM_METRICS_SUBTITLE";
export const CUSTOM_METRICS_MEASURE_COLUMN = "CUSTOM_METRICS_MEASURE_COLUMN";
export const CUSTOM_METRICS_UNIT_COLUMN = "CUSTOM_METRICS_UNIT_COLUMN";
export const CUSTOM_METRICS_REMAP_PRIOR_BUTTON =
  "CUSTOM_METRICS_REMAP_PRIOR_BUTTON";

export const MANUAL_CLAIMS_TITLE = "MANUAL_CLAIMS_TITLE";
export const MANUAL_CLAIMS_CANCEL_MERGE_CLAIMS_BUTTON =
  "MANUAL_CLAIMS_CANCEL_MERGE_CLAIMS_BUTTON";
export const MANUAL_CLAIMS_MERGE_CLAIMS_BUTTON =
  "MANUAL_CLAIMS_MERGE_CLAIMS_BUTTON";
export const MANUAL_CLAIMS_YEAR_COLUMN = "MANUAL_CLAIMS_YEAR_COLUMN";
export const MANUAL_CLAIMS_LINE_COLUMN = "MANUAL_CLAIMS_LINE_COLUMN";
export const MANUAL_CLAIMS_LOSS_AMOUNT_COLUMN =
  "MANUAL_CLAIMS_LOSS_AMOUNT_COLUMN";
export const MANUAL_CLAIMS_CLAIMANT_COLUMN = "MANUAL_CLAIMS_CLAIMANT_COLUMN";
export const MANUAL_CLAIMS_DESCRIPTION_COLUMN =
  "MANUAL_CLAIMS_DESCRIPTION_COLUMN";
export const MANUAL_CLAIMS_STATUS_COLUMN = "MANUAL_CLAIMS_STATUS_COLUMN";
export const MANUAL_CLAIMS_DATE_CLOSED_COLUMN =
  "MANUAL_CLAIMS_DATE_CLOSED_COLUMN";
export const MANUAL_CLAIMS_REQUIRED_FIELDS_TOOLTIP =
  "MANUAL_CLAIMS_REQUIRED_FIELDS_TOOLTIP";
export const MANUAL_CLAIMS_INVALID_DATE_TOOLTIP =
  "MANUAL_CLAIMS_INVALID_DATE_TOOLTIP";
export const MANUAL_CLAIMS_OPEN_STATUS = "MANUAL_CLAIMS_OPEN_STATUS";
export const MANUAL_CLAIMS_CLOSED_STATUS = "MANUAL_CLAIMS_CLOSED_STATUS";

export const LEVELLED_SCENARIOS_COMPONENT_TITLE =
  "LEVELLED_SCENARIOS_COMPONENT_TITLE";
export const LEVELLED_SCENARIOS_COMPONENT_SUBTITLE =
  "LEVELLED_SCENARIOS_COMPONENT_SUBTITLE";
export const LEVELLED_SCENARIOS_RESET_TOOLTIP =
  "LEVELLED_SCENARIOS_RESET_TOOLTIP";
export const LEVELLED_SCENARIOS_CLEAR_TOOLTIP =
  "LEVELLED_SCENARIOS_CLEAR_TOOLTIP";

export const BINARY_COVERAGES_RESET_TO_LATEST =
  "BINARY_COVERAGES_RESET_TO_LATEST";

export const CLAIMS_TOP_TEN_TITLE = "CLAIMS_TOP_TEN_TITLE";
export const CLAIMS_TOP_TEN_SUBTITLE = "CLAIMS_TOP_TEN_SUBTITLE";
export const CLAIMS_NO_DATA_MESSAGE = "CLAIMS_NO_DATA_MESSAGE";

export const US_STATE_LAW_TITLE = "US_STATE_LAW_TITLE";
export const US_STATE_LAW_SUBTITLE = "US_STATE_LAW_SUBTITLE";
export const SOVEREIGN_IMMUNITY_TITLE = "SOVEREIGN_IMMUNITY_TITLE";

export const ACTIVE_LAYER_PANEL_TITLE = "ACTIVE_LAYER_PANEL_TITLE";
export const ACTIVE_LAYER_PANEL_SUBTITLE = "ACTIVE_LAYER_PANEL_SUBTITLE";
export const ACTIVE_LAYER_PANEL_LIMIT_LABEL = "ACTIVE_LAYER_PANEL_LIMIT_LABEL";
export const ACTIVE_LAYER_PANEL_ATTACHMENT_LABEL =
  "ACTIVE_LAYER_PANEL_ATTACHMENT_LABEL";
export const ACTIVE_LAYER_PANEL_INCLUDE_SIR_LABEL =
  "ACTIVE_LAYER_PANEL_INCLUDE_SIR_LABEL";
export const ACTIVE_LAYER_PANEL_REQUIRED_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_REQUIRED_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_EFFECTIVE_ATTACHMENT_LABEL =
  "ACTIVE_LAYER_PANEL_EFFECTIVE_ATTACHMENT_LABEL";
export const ACTIVE_LAYER_PANEL_AGGREGATE_LIMIT_LABEL =
  "ACTIVE_LAYER_PANEL_AGGREGATE_LIMIT_LABEL";
export const ACTIVE_LAYER_PANEL_PCO_AGGREGATE_LABEL =
  "ACTIVE_LAYER_PANEL_PCO_AGGREGATE_LABEL";
export const ACTIVE_LAYER_PANEL_OUR_LIMIT_LABEL =
  "ACTIVE_LAYER_PANEL_OUR_LIMIT_LABEL";
export const ACTIVE_LAYER_PANEL_OUR_SHARE_LABEL =
  "ACTIVE_LAYER_PANEL_OUR_SHARE_LABEL";
export const ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_LABEL =
  "ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_LABEL";
export const ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_ANNUALLY =
  "ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_ANNUALLY";
export const ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_SEMI_ANNUALLY =
  "ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_SEMI_ANNUALLY";
export const ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_QUARTERLY =
  "ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_QUARTERLY";
export const ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_MONTHLY =
  "ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_MONTHLY";
export const ACTIVE_LAYER_PANEL_TRIA_STATUS_LABEL =
  "ACTIVE_LAYER_PANEL_TRIA_STATUS_LABEL";
export const ACTIVE_LAYER_PANEL_TRIA_STATUS_NOT_INCLUDED =
  "ACTIVE_LAYER_PANEL_TRIA_STATUS_NOT_INCLUDED";
export const ACTIVE_LAYER_PANEL_TRIA_STATUS_INCLUDED =
  "ACTIVE_LAYER_PANEL_TRIA_STATUS_INCLUDED";
export const ACTIVE_LAYER_PANEL_TRIA_STATUS_GROSS_UP =
  "ACTIVE_LAYER_PANEL_TRIA_STATUS_GROSS_UP";
export const ACTIVE_LAYER_PANEL_TRIA_STATUS_INCLUDED_GROSS_UP =
  "ACTIVE_LAYER_PANEL_TRIA_STATUS_INCLUDED_GROSS_UP";
export const ACTIVE_LAYER_PANEL_TRIA_LABEL = "ACTIVE_LAYER_PANEL_TRIA_LABEL";
export const ACTIVE_LAYER_PANEL_TRIA_AMOUNT_LABEL =
  "ACTIVE_LAYER_PANEL_TRIA_AMOUNT_LABEL";
export const ACTIVE_LAYER_PANEL_OUR_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_OUR_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_OUR_PREMIUM_INC_TRIA_LABEL =
  "ACTIVE_LAYER_PANEL_OUR_PREMIUM_INC_TRIA_LABEL";
export const ACTIVE_LAYER_PANEL_AUTHORIZED_LIMIT_LABEL =
  "ACTIVE_LAYER_PANEL_AUTHORIZED_LIMIT_LABEL";
export const ACTIVE_LAYER_PANEL_BROKERAGE_LABEL =
  "ACTIVE_LAYER_PANEL_BROKERAGE_LABEL";
export const ACTIVE_LAYER_PANEL_SLIP_FEE_LABEL =
  "ACTIVE_LAYER_PANEL_SLIP_FEE_LABEL";
export const ACTIVE_LAYER_PANEL_PREMOPS_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_PREMOPS_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_PCO_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_PCO_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_LIQUOR_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_LIQUOR_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_AUTO_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_AUTO_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_CHARGED_TO_TECHNICAL_PCT_LABEL =
  "ACTIVE_LAYER_PANEL_CHARGED_TO_TECHNICAL_PCT_LABEL";
export const ACTIVE_LAYER_PANEL_POLICY_FEE_LABEL =
  "ACTIVE_LAYER_PANEL_POLICY_FEE_LABEL";
export const ACTIVE_LAYER_PANEL_INSPECTION_FEE_LABEL =
  "ACTIVE_LAYER_PANEL_INSPECTION_FEE_LABEL";
export const ACTIVE_LAYER_PANEL_LOSS_CONTROL_FEE_LABEL =
  "ACTIVE_LAYER_PANEL_LOSS_CONTROL_FEE_LABEL";
export const ACTIVE_LAYER_PANEL_OAC_LABEL = "ACTIVE_LAYER_PANEL_OAC_LABEL";
export const ACTIVE_LAYER_PANEL_EXPENSES_LABEL =
  "ACTIVE_LAYER_PANEL_EXPENSES_LABEL";
export const ACTIVE_LAYER_PANEL_COMMENT_LABEL =
  "ACTIVE_LAYER_PANEL_COMMENT_LABEL";
export const ACTIVE_LAYER_PANEL_GROSS_PPM_LABEL =
  "ACTIVE_LAYER_PANEL_GROSS_PPM_LABEL";
export const ACTIVE_LAYER_PANEL_INCEPTION_LABEL =
  "ACTIVE_LAYER_PANEL_INCEPTION_LABEL";
export const ACTIVE_LAYER_PANEL_GNULR_LABEL = "ACTIVE_LAYER_PANEL_GNULR_LABEL";
export const ACTIVE_LAYER_PANEL_MINIMUM_EARNED_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_MINIMUM_EARNED_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_REFERENCE_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_REFERENCE_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_WRAP_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_WRAP_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_WRAP_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_WRAP_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_INCLUDED_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_INCLUDED_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_PREMIUM_EX_WRAP_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_PREMIUM_EX_WRAP_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_BROKERAGE_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_BROKERAGE_LABEL";
export const ACTIVE_LAYER_PANEL_PUNI_WRAP_BROKERAGE_LABEL =
  "ACTIVE_LAYER_PANEL_PUNI_WRAP_BROKERAGE_LABEL";
export const ACTIVE_LAYER_PANEL_FAC_LABEL = "ACTIVE_LAYER_PANEL_FAC_LABEL";
export const ACTIVE_LAYER_PANEL_FAC_PREMIUM_LABEL =
  "ACTIVE_LAYER_PANEL_FAC_PREMIUM_LABEL";
export const ACTIVE_LAYER_PANEL_GELR_LABEL = "ACTIVE_LAYER_PANEL_GELR_LABEL";
export const ACTIVE_LAYER_PANEL_LAYER_REFERENCE_LABEL =
  "ACTIVE_LAYER_PANEL_LAYER_REFERENCE_LABEL";
export const ACTIVE_LAYER_PANEL_EXTERNAL_SYSTEM_REFERENCE_LABEL =
  "ACTIVE_LAYER_PANEL_EXTERNAL_SYSTEM_REFERENCE_LABEL";

export const EXPOSURE_FLAGS_TITLE = "EXPOSURE_FLAGS_TITLE";
export const EXPOSURE_FLAGS_SUBTITLE = "EXPOSURE_FLAGS_SUBTITLE";
export const EXPOSURE_FLAG_TYPE_COLUMN = "EXPOSURE_FLAG_TYPE_COLUMN";
export const EXPOSURE_FLAG_CATEGORY_COLUMN = "EXPOSURE_FLAG_CATEGORY_COLUMN";
export const EXPOSURE_FLAG_COMMENTS_COLUMN = "EXPOSURE_FLAG_COMMENTS_COLUMN";
export const EXPOSURE_FLAGS_RESET_TO_LATEST = "EXPOSURE_FLAGS_RESET_TO_LATEST";

export const UW_JUDGMENT_TITLE = "UW_JUDGMENT_TITLE";
export const UW_JUDGMENT_LABEL_COLUMN = "UW_JUDGMENT_LABEL_COLUMN";
export const UW_JUDGMENT_IMPACT_TOOLTIP = "UW_JUDGMENT_IMPACT_TOOLTIP";
export const UW_JUDGMENT_APPLIED_TOOLTIP = "UW_JUDGMENT_APPLIED_TOOLTIP";
export const UW_JUDGMENT_APPIED_IMPACT_COLUMN =
  "UW_JUDGMENT_APPIED_IMPACT_COLUMN";
export const UW_JUDGMENT_IMPACT_COLUMN = "UW_JUDGMENT_IMPACT_COLUMN";
export const UW_JUDGMENT_SUBTITLE = "UW_JUDGMENT_SUBTITLE";
export const UW_JUDGMENT_COMMENTS_COLUMN = "UW_JUDGMENT_COMMENTS_COLUMN";
export const UW_JUDGMENT_OVERALL_LABEL = "UW_JUDGMENT_OVERALL_LABEL";

export const ENDORSEMENTS = "ENDORSEMENTS";
export const AVAILABLE_ENDORSEMENTS_TITLE = "AVAILABLE_ENDORSEMENTS_TITLE";
export const ENDORSEMENTS_NO_CONFIG = "ENDORSEMENTS_NO_CONFIG";
export const ENDORSEMENTS_SELECT_ALL = "ENDORSEMENTS_SELECT_ALL";
export const ENDORSEMENTS_OVERRIDE_REQUIRED = "ENDORSEMENTS_OVERRIDE_REQUIRED";
export const ENDORSEMENTS_DESELECT_ALL = "ENDORSEMENTS_DESELECT_ALL";
export const ENDORSEMENTS_RESET_TO_DEFAULT = "ENDORSEMENTS_RESET_TO_DEFAULT";
export const ENDORSEMENTS_RESET_ORDERING = "ENDORSEMENTS_RESET_ORDERING";
export const UNKNOWN_ENDORSEMENTS_TITLE = "UNKNOWN_ENDORSEMENTS_TITLE";
export const UNKNOWN_ENDORSEMENTS_DESCRIPTION =
  "UNKNOWN_ENDORSEMENTS_DESCRIPTION";
export const SELECTED_ENDORSEMENTS_TITLE = "SELECTED_ENDORSEMENTS_TITLE";

export const EMAIL_RECEIVER_TITLE = "EMAIL_RECEIVER_TITLE";
export const EMAIL_RECEIVER_ADD_INBOX = "EMAIL_RECEIVER_ADD_INBOX";

export const ATTACHMENTS_TITLE = "ATTACHMENTS_TITLE";
export const ATTACHMENTS_DOWNLOAD_ALL = "ATTACHMENTS_DOWNLOAD_ALL";

export const RISK_SUMMARY_TITLE = "RISK_SUMMARY_TITLE";
export const INSURED_DETAILS_TITLE = "INSURED_DETAILS_TITLE";
export const INSURED = "INSURED";
export const COMPANY_SEARCH_TOOLTIP = "COMPANY_SEARCH_TOOLTIP";
export const ASSISTANT_TITLE = "ASSISTANT_TITLE";
export const ASSISTANT_SUBTITLE = "ASSISTANT_SUBTITLE";
export const ADD_NEW_ASSISTANT = "ADD_NEW_ASSISTANT";
export const ASSISTANT_CREATE_TITLE = "ASSISTANT_CREATE_TITLE";
export const RISK_DESCRIPTION = "RISK_DESCRIPTION";
export const INSURED_ADDRESS = "INSURED_ADDRESS";
export const INSURED_ADDRESS_STREET_LABEL = "INSURED_ADDRESS_STREET_LABEL";
export const INSURED_ADDRESS_STREET2_LABEL = "INSURED_ADDRESS_STREET2_LABEL";
export const INSURED_ADDRESS_CITY_LABEL = "INSURED_ADDRESS_CITY_LABEL";
export const INSURED_ADDRESS_STATE_LABEL = "INSURED_ADDRESS_STATE_LABEL";
export const INSURED_ADDRESS_ZIP_LABEL = "INSURED_ADDRESS_ZIP_LABEL";
export const PERSON_ADDRESS_STREET_LABEL = "PERSON_ADDRESS_STREET_LABEL";
export const PERSON_ADDRESS_STREET2_LABEL = "PERSON_ADDRESS_STREET2_LABEL";
export const PERSON_ADDRESS_CITY_LABEL = "PERSON_ADDRESS_CITY_LABEL";
export const PERSON_ADDRESS_STATE_LABEL = "PERSON_ADDRESS_STATE_LABEL";
export const PERSON_ADDRESS_ZIP_LABEL = "PERSON_ADDRESS_ZIP_LABEL";
export const MAILING_ADDRESS = "MAILING_ADDRESS";
export const INCEPTION = "INCEPTION";
export const EXPIRATION = "EXPIRATION";
export const PRO_RATA = "PRO_RATA";
export const TRANSACTION = "TRANSACTION";
export const EFFECTIVE_DATE = "EFFECTIVE_DATE";
export const EFFECTIVE_EXPIRATION = "EFFECTIVE_EXPIRATION";
export const PROGRAM_REFERENCE = "PROGRAM_REFERENCE";
export const QUOTE_REFERENCE = "QUOTE_REFERENCE";
export const POLICY_SUMMARY = "POLICY_SUMMARY";
export const PREFERRED_UNDERWRITER = "PREFERRED_UNDERWRITER";
export const SECONDARY_UNDERWRITER = "SECONDARY_UNDERWRITER";
export const UNDERWRITER_ASSISTANT = "UNDERWRITER_ASSISTANT";
export const DATE_RECEIVED = "DATE_RECEIVED";
export const QUOTE_DEADLINE = "QUOTE_DEADLINE";
export const QUOTE_DATE = "QUOTE_DATE";
export const QUOTE_VALID_UNTIL = "QUOTE_VALID_UNTIL";
export const WARRANTY_DATE = "WARRANTY_DATE";
export const PRIORITY = "PRIORITY";
export const PROGRAM_BROKERAGE = "PROGRAM_BROKERAGE";
export const PROGRAM_REQUESTED_BROKERAGE = "PROGRAM_REQUESTED_BROKERAGE";
export const PROGRAM_OAC = "PROGRAM_OAC";
export const PROGRAM_TARGET_PROFIT = "PROGRAM_TARGET_PROFIT";
export const PROGRAM_GNULR = "PROGRAM_GNULR";
export const PROGRAM_EXPENSES = "PROGRAM_EXPENSES";
export const PROGRAM_POLICY_FEE = "PROGRAM_POLICY_FEE";
export const PROGRAM_INSPECTION_FEE = "PROGRAM_INSPECTION_FEE";
export const PROGRAM_NON_RENEWING = "PROGRAM_NON_RENEWING";
export const PROGRAM_MULTI_YEAR_DEAL = "PROGRAM_MULTI_YEAR_DEAL";
export const PROGRAM_CANCEL_AT_FIRST_ANNIVERSARY =
  "PROGRAM_CANCEL_AT_FIRST_ANNIVERSARY";
export const PROGRAM_AUDITABLE = "PROGRAM_AUDITABLE";
export const PROGRAM_FORM_OF_BUSINESS_LABEL = "PROGRAM_FORM_OF_BUSINESS_LABEL";
export const PRICING_NAICS = "PRICING_NAICS";
export const COMPANY_NAICS = "COMPANY_NAICS";
export const COMPANY_SIC = "COMPANY_SIC";
export const COMPANY_SIC_SUBTITLE = "COMPANY_SIC_SUBTITLE";
export const LOCATION = "LOCATION";
export const TURNOVER = "TURNOVER";
export const CURRENCY = "CURRENCY";
export const REASSURED = "REASSURED";
export const REINSURED = "REINSURED";
export const MGA = "MGA";
export const CESSION_LIMIT_FROM = "CESSION_LIMIT_FROM";
export const CESSION_LIMIT_TO = "CESSION_LIMIT_TO";
export const DEFAULT_REINSURANCE = "DEFAULT_REINSURANCE";
export const DEFAULT_PAPER_PROVIDER = "DEFAULT_PAPER_PROVIDER";
export const IS_SANCTIONS_SEARCH_COMPLETE = "IS_SANCTIONS_SEARCH_COMPLETE";
export const PROGRAM_REGULATORY_EXEMPTIONS = "PROGRAM_REGULATORY_EXEMPTIONS";
export const NEW_YORK_FREE_TRADE_ZONE_LABEL = "NEW_YORK_FREE_TRADE_ZONE_LABEL";
export const NEW_YORK_FREE_TRADE_ZONE_RISK_CODE =
  "NEW_YORK_FREE_TRADE_ZONE_RISK_CODE";
export const NEW_YORK_FREE_TRADE_ZONE_COMMENT =
  "NEW_YORK_FREE_TRADE_ZONE_COMMENT";
export const DEREGULATED_LABEL = "DEREGULATED_LABEL";
export const DEREGULATED_TYPE = "DEREGULATED_TYPE";
export const DEREGULATED_JURISDICTION = "DEREGULATED_JURISDICTION";
export const DEREGULATED_COMMENT = "DEREGULATED_COMMENT";

export const LAYER_PRICING_MODEL_SELECT_LABEL =
  "LAYER_PRICING_MODEL_SELECT_LABEL";
export const LAYER_PRICING_NON_DEFAULT_MODEL_MESSAGE =
  "LAYER_PRICING_NON_DEFAULT_MODEL_MESSAGE";
export const PRICING_TABLE_EXPECTED_LOSS_COST_COLUMN =
  "PRICING_TABLE_EXPECTED_LOSS_COST_COLUMN";
export const PRICING_TABLE_PURE_PREMIUM_COLUMN =
  "PRICING_TABLE_PURE_PREMIUM_COLUMN";
export const PRICING_TABLE_REQUIRED_PREMIUM_COLUMN =
  "PRICING_TABLE_REQUIRED_PREMIUM_COLUMN";
export const PRICING_TABLE_TARGET_PRICE_COLUMN =
  "PRICING_TABLE_TARGET_PRICE_COLUMN";
export const PRICING_TABLE_LOSS_RATIO_COLUMN =
  "PRICING_TABLE_LOSS_RATIO_COLUMN";
export const PRICING_TABLE_GNULR_COLUMN = "PRICING_TABLE_GNULR_COLUMN";

export const SELF_INSURED_RETENTIONS_TITLE = "SELF_INSURED_RETENTIONS_TITLE";
export const SELF_INSURED_RETENTIONS_COVERAGE =
  "SELF_INSURED_RETENTIONS_COVERAGE";
export const SELF_INSURED_RETENTIONS_RETENTION_TYPE =
  "SELF_INSURED_RETENTIONS_RETENTION_TYPE";
export const SELF_INSURED_RETENTIONS_AMOUNT = "SELF_INSURED_RETENTIONS_AMOUNT";
export const SELF_INSURED_RETENTIONS_NOTES = "SELF_INSURED_RETENTIONS_NOTES";
export const SELF_INSURED_RETENTIONS_NOT_SELECTED =
  "SELF_INSURED_RETENTIONS_NOT_SELECTED";
export const SELF_INSURED_RETENTIONS_ALL = "SELF_INSURED_RETENTIONS_ALL";
export const SELF_INSURED_RETENTIONS_OTHER = "SELF_INSURED_RETENTIONS_OTHER";
export const RETENTIONS_RESET_TO_DEFAULTS = "RETENTIONS_RESET_TO_DEFAULTS";
export const RETENTIONS_DEFAULTS_MISMATCH_MESSAGE =
  "RETENTIONS_DEFAULTS_MISMATCH_MESSAGE";

export const PARTICIPATION_TABLE_TITLE = "PARTICIPATION_TABLE_TITLE";
export const PARTICIPATION_TABLE_NO_DATA = "PARTICIPATION_TABLE_NO_DATA";
export const PARTICIPATION_TABLE_CARRIER = "PARTICIPATION_TABLE_CARRIER";
export const PARTICIPATION_TABLE_TOTAL_LIMIT =
  "PARTICIPATION_TABLE_TOTAL_LIMIT";
export const PARTICIPATION_TABLE_TOTAL_PREMIUM =
  "PARTICIPATION_TABLE_TOTAL_PREMIUM";
export const TOWER_RATE_CHART_TITLE = "TOWER_RATE_CHART_TITLE";
export const TOWER_RATE_CHART_NO_DATA = "TOWER_RATE_CHART_NO_DATA";
export const DOCUMENT_ISSUANCE_DATE = "DOCUMENT_ISSUANCE_DATE";
export const DOCUMENTS_ISSUED = "DOCUMENTS_ISSUED";
export const IS_QUOTE_ISSUED = "IS_QUOTE_ISSUED";
export const IS_BINDER_ISSUED = "IS_BINDER_ISSUED";
export const IS_POLICY_DRAFTED = "IS_POLICY_DRAFTED";
export const IS_POLICY_ISSUED = "IS_POLICY_ISSUED";
export const IS_PUNI_QUOTE_ISSUED = "IS_PUNI_QUOTE_ISSUED";
export const IS_PUNI_BINDER_ISSUED = "IS_PUNI_BINDER_ISSUED";
export const IS_PUNI_POLICY_ISSUED = "IS_PUNI_POLICY_ISSUED";
export const POLICY_ISSUANCE_STATUS = "POLICY_ISSUANCE_STATUS";

export const LAYER_PRICING_CHART_TITLE = "LAYER_PRICING_CHART_TITLE";
export const LAYER_PRICING_CHART_SUBTITLE = "LAYER_PRICING_CHART_SUBTITLE";
export const LAYER_PRICING_CHART_Y_AXIS_LABEL =
  "LAYER_PRICING_CHART_Y_AXIS_LABEL";
export const LAYER_PRICING_CHART_GNULR_LABEL =
  "LAYER_PRICING_CHART_GNULR_LABEL";
export const LAYER_PRICING_JUSTIFICATION_TITLE =
  "LAYER_PRICING_JUSTIFICATION_TITLE";

export const POLICY_TYPE_LABEL = "POLICY_TYPE_LABEL";
export const POLICY_TYPE_NONE_OPTION = "POLICY_TYPE_NONE_OPTION";
export const PAYMENT_TERMS_FORM_PAYMENT_DAYS =
  "PAYMENT_TERMS_FORM_PAYMENT_DAYS";
export const PAYMENT_TERMS_FORM_PAYMENT_DUE_DATE =
  "PAYMENT_TERMS_FORM_PAYMENT_DUE_DATE";
export const FOLLOWED_POLICY_LABEL = "FOLLOWED_POLICY_LABEL";
export const RENEWED_FROM_LAYER_LABEL = "RENEWED_FROM_LAYER_LABEL";
export const POLICY_FORM_LABEL = "POLICY_FORM_LABEL";
export const PROCUREMENT_LABEL = "PROCUREMENT_LABEL";
export const PROCUREMENT_NONE_OPTION = "PROCUREMENT_NONE_OPTION";

export const GENERATE_POLICY_NUMBER_TOOLTIP = "GENERATE_POLICY_NUMBER_TOOLTIP";

export const BASE_LAYER_BURN_CLAIMS_COMPONENT_TITLE =
  "BASE_LAYER_BURN_CLAIMS_COMPONENT_TITLE";
export const BASE_LAYER_BURN_CLAIMS_COMPONENT_SUBTITLE =
  "BASE_LAYER_BURN_CLAIMS_COMPONENT_SUBTITLE";
export const BASE_LAYER_BURN_CLAIMS_LIMIT_SLIDER_LABEL =
  "BASE_LAYER_BURN_CLAIMS_LIMIT_SLIDER_LABEL";
export const BASE_LAYER_BURN_CLAIMS_ATTACHMENT_SLIDER_LABEL =
  "BASE_LAYER_BURN_CLAIMS_ATTACHMENT_SLIDER_LABEL";
export const BASE_LAYER_BURN_CLAIMS_FROM_DATE_LABEL =
  "BASE_LAYER_BURN_CLAIMS_FROM_DATE_LABEL";
export const BASE_LAYER_BURN_CLAIMS_TO_DATE_LABEL =
  "BASE_LAYER_BURN_CLAIMS_TO_DATE_LABEL";
export const BASE_LAYER_BURN_CLAIMS_RESET_BUTTON_LABEL =
  "BASE_LAYER_BURN_CLAIMS_RESET_BUTTON_LABEL";
export const BASE_LAYER_BURN_SCALING_EXPOSURE_LABEL =
  "BASE_LAYER_BURN_SCALING_EXPOSURE_LABEL";
export const BASE_LAYER_BURN_LOSSES_BY_YEAR_LABEL =
  "BASE_LAYER_BURN_LOSSES_BY_YEAR_LABEL";
export const BASE_LAYER_BURN_PRICING_TITLE = "BASE_LAYER_BURN_PRICING_TITLE";
export const BASE_LAYER_BURN_PRICING_SUBTITLE =
  "BASE_LAYER_BURN_PRICING_SUBTITLE";
export const BASE_LAYER_BURN_SIMPLE_BURN_LABEL =
  "BASE_LAYER_BURN_SIMPLE_BURN_LABEL";
export const BASE_LAYER_BURN_LOSS_PER_UNIT_EXPOSURE_LABEL =
  "BASE_LAYER_BURN_LOSS_PER_UNIT_EXPOSURE_LABEL";
export const BASE_LAYER_BURN_EXPOSURE_SCALED_BURN_LABEL =
  "BASE_LAYER_BURN_EXPOSURE_SCALED_BURN_LABEL";
export const BASE_LAYER_BURN_SELECTED_PRICE_LABEL =
  "BASE_LAYER_BURN_SELECTED_PRICE_LABEL";
export const BASE_LAYER_BURN_JUSTIFICATION_LABEL =
  "BASE_LAYER_BURN_JUSTIFICATION_LABEL";

export const EXPIRING_PROGRAM_TITLE = "EXPIRING_PROGRAM_TITLE";
export const EXPIRING_PROGRAM_SUBTITLE = "EXPIRING_PROGRAM_SUBTITLE";

export const EXPIRING_PROGRAM_CARRIER = "EXPIRING_PROGRAM_CARRIER";
export const EXPIRING_PROGRAM_LIMIT = "EXPIRING_PROGRAM_LIMIT";
export const EXPIRING_PROGRAM_ATTACHMENT = "EXPIRING_PROGRAM_ATTACHMENT";
export const EXPIRING_PROGRAM_MARKET_GWP = "EXPIRING_PROGRAM_MARKET_GWP";
export const EXPIRING_PROGRAM_MARKET_RPM = "EXPIRING_PROGRAM_MARKET_RPM";
export const EXPIRING_PROGRAM_RATE_RELATIVITY =
  "EXPIRING_PROGRAM_RATE_RELATIVITY";

export const FILTERED_CLAIMS_TITLE_PREFIX = "FILTERED_CLAIMS_TITLE_PREFIX";
export const FILTERED_CLAIMS_SUBTITLE = "FILTERED_CLAIMS_SUBTITLE";
export const FILTERED_CLAIMS_LIMIT_SLIDER = "FILTERED_CLAIMS_LIMIT_SLIDER";
export const FILTERED_CLAIMS_ATTACHMENT_SLIDER =
  "FILTERED_CLAIMS_ATTACHMENT_SLIDER";
export const FILTERED_CLAIMS_CLEAR_BUTTON = "FILTERED_CLAIMS_CLEAR_BUTTON";
export const FILTERED_CLAIMS_FROM_DATE = "FILTERED_CLAIMS_FROM_DATE";
export const FILTERED_CLAIMS_TO_DATE = "FILTERED_CLAIMS_TO_DATE";
export const FILTERED_CLAIMS_FREE_LIMIT_WARNING =
  "FILTERED_CLAIMS_FREE_LIMIT_WARNING";
export const FILTERED_CLAIMS_USE_AS_BASE_LAYER_BUTTON =
  "FILTERED_CLAIMS_USE_AS_BASE_LAYER_BUTTON";

export const LOSS_FREQUENCY_TITLE = "LOSS_FREQUENCY_TITLE";
export const LOSS_FREQUENCY_SUBTITLE = "LOSS_FREQUENCY_SUBTITLE";
export const LOSS_SEVERITY_TITLE = "LOSS_SEVERITY_TITLE";
export const LOSS_SEVERITY_SUBTITLE = "LOSS_SEVERITY_SUBTITLE";
export const LOSS_AGGREGATE_TITLE = "LOSS_AGGREGATE_TITLE";
export const LOSS_AGGREGATE_SUBTITLE = "LOSS_AGGREGATE_SUBTITLE";

export const LOSS_AGGREGATE_BY_LINE_TITLE = "LOSS_AGGREGATE_BY_LINE_TITLE";
export const LOSS_AGGREGATE_BY_LINE_SUBTITLE =
  "LOSS_AGGREGATE_BY_LINE_SUBTITLE";

export const FREQUENCY_DATA_NAME = "FREQUENCY_DATA_NAME";
export const SEVERITY_DATA_NAME = "SEVERITY_DATA_NAME";
export const AGGREGATE_DATA_NAME = "AGGREGATE_DATA_NAME";
export const DEVELOPMENT_AND_INFLATION = "DEVELOPMENT_AND_INFLATION";

export const PUNI_BROKER = "PUNI_BROKER_TITLE";
export const RETAIL_BROKER_TITLE = "RETAIL_BROKER_TITLE";
export const SURPLUS_LINES_BROKER_TITLE = "SURPLUS_LINES_BROKER_TITLE";
export const PRODUCER_BROKER_TITLE = "PRODUCER_BROKER_TITLE";
export const WHOLESALE_BROKER_TITLE = "WHOLESALE_BROKER_TITLE";
export const WHOLESALE_BROKER_OPTION = "WHOLESALE_BROKER_OPTION_TITLE";

export const INDUSTRY_CLASS = "INDUSTRY_CLASS";
export const INDUSTRY_CLASS_SUBTITLE = "INDUSTRY_CLASS_SUBTITLE";

export const PRODUCT_LINE = "PRODUCT_LINE";
export const NO_PRODUCT_LINE = "NO_PRODUCT_LINE";
export const PRODUCT_LINE_SUBTITLE = "PRODUCT_LINE_SUBTITLE";

export const REGIONAL_COVERAGE = "REGIONAL_COVERAGE";
export const PERILS_COVERAGE = "PERILS_COVERAGE";
export const REQUIRED_PREMIUM = "REQUIRED_PREMIUM";
export const TARGET_PROFIT = "TARGET_PROFIT";
export const LAYER_REINSURANCE = "LAYER_REINSURANCE";

export const PERCENTAGE_SUBLIMITS = "PERCENTAGE_SUBLIMITS";
export const ADD_SUBLIMIT = "ADD_SUBLIMIT";
export const NO_SUBLIMITS_DATA = "NO_SUBLIMITS_DATA";
export const SUBLIMIT_NAME = "SUBLIMIT_NAME";
export const SUBLIMIT_VALUE = "SUBLIMIT_VALUE";
export const SUBLIMIT_PERCENTAGE = "SUBLIMIT_PERCENTAGE";
export const SUBLIMIT_ACTIVE = "SUBLIMIT_ACTIVE";
export const TOTAL_SUBLIMIT_VALUE_EXCEEDS_LAYER_LIMIT =
  "TOTAL_SUBLIMIT_VALUE_EXCEEDS_LAYER_LIMIT";
export const TOTAL_SUBLIMIT_PERCENTAGE_EXCEEDS_100 =
  "TOTAL_SUBLIMIT_PERCENTAGE_EXCEEDS_100";
export const TOTAL_SUBLIMIT_PERCENTAGE_LESS_THAN_100 =
  "TOTAL_SUBLIMIT_PERCENTAGE_LESS_THAN_100";
export const SUBLIMITS_RESET_TO_LATEST = "SUBLIMITS_RESET_TO_LATEST";

export const DOWNLOAD_BUTTON = "DOWNLOAD_BUTTON";
export const DOWNLOAD_CLAIMS_DATA_TITLE = "DOWNLOAD_CLAIMS_DATA_TITLE";
export const FILENAME_TOOLTIP = "FILENAME_TOOLTIP";
export const FILENAME_COLUMN = "FILENAME_COLUMN";
export const SHEET_TOOLTIP = "SHEET_TOOLTIP";
export const SHEET_COLUMN = "SHEET_COLUMN";
export const TRANSFORMED_TOOLTIP = "TRANSFORMED_TOOLTIP";
export const TRANSFORMED_COLUMN = "TRANSFORMED_COLUMN";
export const ORIGINAL_TOOLTIP = "ORIGINAL_TOOLTIP";
export const ORIGINAL_COLUMN = "ORIGINAL_COLUMN";
export const VIEW_COLUMN_MAPPINGS_TOOLTIP = "VIEW_COLUMN_MAPPINGS_TOOLTIP";

export const CATEGORY_CODE_TITLE = "CATEGORY_CODE_TITLE";
export const CATEGORY_CODE_SUBTITLE = "CATEGORY_CODE_SUBTITLE";
export const CATEGORY_CODE_LABEL = "CATEGORY_CODE_LABEL";

export const CURRENCIES_TITLE = "CURRENCIES_TITLE";
export const CURRENCIES_SUBTITLE = "CURRENCIES_SUBTITLE";
export const CURRENCIES_CURRENCY_CODE_LABEL = "CURRENCIES_CURRENCY_CODE_LABEL";
export const CURRENCIES_FX_RATE_LABEL = "CURRENCIES_FX_RATE_LABEL";
export const CURRENCIES_USD_ERROR_TOOLTIP = "CURRENCIES_USD_ERROR_TOOLTIP";

export const CLAIMS_TABLE_TOP_CLAIMS = "CLAIMS_TABLE_TOP_CLAIMS";
export const CLAIMS_TABLE_MERGE_SELECTED = "CLAIMS_TABLE_MERGE_SELECTED";
export const CLAIMS_TABLE_HIDE_NOTES = "CLAIMS_TABLE_HIDE_NOTES";
export const CLAIMS_TABLE_SHOW_NOTES = "CLAIMS_TABLE_SHOW_NOTES";
export const CLAIMS_TABLE_TO_MERGE = "CLAIMS_TABLE_TO_MERGE";
export const CLAIMS_TABLE_DATE = "CLAIMS_TABLE_DATE";
export const CLAIMS_TABLE_NUM_CLAIMS = "CLAIMS_TABLE_NUM_CLAIMS";
export const CLAIMS_TABLE_STATUS = "CLAIMS_TABLE_STATUS";
export const CLAIMS_TABLE_REPORTED = "CLAIMS_TABLE_REPORTED";
export const CLAIMS_TABLE_ULTIMATE = "CLAIMS_TABLE_ULTIMATE";
export const CLAIMS_TABLE_OVERRIDE = "CLAIMS_TABLE_OVERRIDE";
export const CLAIMS_TABLE_LINE = "CLAIMS_TABLE_LINE";
export const CLAIMS_TABLE_CLAIMANT = "CLAIMS_TABLE_CLAIMANT";
export const CLAIMS_TABLE_DESCRIPTION = "CLAIMS_TABLE_DESCRIPTION";
export const CLAIMS_TABLE_DATE_CLOSED = "CLAIMS_TABLE_DATE_CLOSED";
export const CLAIMS_TABLE_SOURCE = "CLAIMS_TABLE_SOURCE";

export const TOP_CLAIMS_TITLE = "TOP_CLAIMS_TITLE";
export const TOP_CLAIMS_DATE_OF_LOSS = "TOP_CLAIMS_DATE_OF_LOSS";
export const TOP_CLAIMS_PAID = "TOP_CLAIMS_PAID";
export const TOP_CLAIMS_RESERVED = "TOP_CLAIMS_RESERVED";
export const TOP_CLAIMS_TOTAL_LOSS = "TOP_CLAIMS_TOTAL_LOSS";
export const TOP_CLAIMS_ULTIMATE_INCURRED = "TOP_CLAIMS_ULTIMATE_INCURRED";
export const TOP_CLAIMS_COVERAGE = "TOP_CLAIMS_COVERAGE";
export const TOP_CLAIMS_CLAIMANT_NAME = "TOP_CLAIMS_CLAIMANT_NAME";
export const TOP_CLAIMS_DESCRIPTION = "TOP_CLAIMS_DESCRIPTION";
export const TOP_CLAIMS_OPEN_CLOSED = "TOP_CLAIMS_OPEN_CLOSED";
export const TOP_CLAIMS_DATE_CLOSED = "TOP_CLAIMS_DATE_CLOSED";

export const FILE_UPLOAD_TITLE = "FILE_UPLOAD_TITLE";
export const FILE_UPLOAD_DROP_MESSAGE = "FILE_UPLOAD_DROP_MESSAGE";
export const FILE_UPLOAD_BROWSE_FILES_BUTTON =
  "FILE_UPLOAD_BROWSE_FILES_BUTTON";
export const FILE_UPLOAD_AS_AT_DATE_LABEL = "FILE_UPLOAD_AS_AT_DATE_LABEL";

export const BROKER_TITLE = "BROKER_TITLE";
export const BROKER_SUBTITLE = "BROKER_SUBTITLE";

export const PEER_GROUP_NO_LAYERS = "PEER_GROUP_NO_LAYERS";
export const PEER_GROUP_PRICING_TITLE = "PEER_GROUP_PRICING_TITLE";
export const PEER_GROUP_PRICING_SUBTITLE = "PEER_GROUP_PRICING_SUBTITLE";
export const ADD_PEERS_TITLE = "ADD_PEERS_TITLE";
export const ADD_PEERS_SUBTITLE = "ADD_PEERS_SUBTITLE";
export const ADD_PEERS_SEARCH_LABEL = "ADD_PEERS_SEARCH_LABEL";

export const PEER_GROUP_COLUMN_INSURED = "PEER_GROUP_COLUMN_INSURED";
export const PEER_GROUP_COLUMN_INCEPTION = "PEER_GROUP_COLUMN_INCEPTION";
export const PEER_GROUP_COLUMN_PRICE = "PEER_GROUP_COLUMN_PRICE";
export const PEER_GROUP_COLUMN_OUR_LIMIT = "PEER_GROUP_COLUMN_OUR_LIMIT";
export const PEER_GROUP_COLUMN_PART_OF = "PEER_GROUP_COLUMN_PART_OF";
export const PEER_GROUP_COLUMN_ATTACHMENT = "PEER_GROUP_COLUMN_ATTACHMENT";
export const PEER_GROUP_COLUMN_GROSS_PPM = "PEER_GROUP_COLUMN_GROSS_PPM";
export const PEER_GROUP_COLUMN_TARGET_PRICE = "PEER_GROUP_COLUMN_TARGET_PRICE";
export const PEER_GROUP_COLUMN_TAC = "PEER_GROUP_COLUMN_TAC";

export const NAICS_PEERS_TITLE = "NAICS_PEERS_TITLE";
export const NAICS_PEERS_SUBTITLE = "NAICS_PEERS_SUBTITLE";
export const NAICS_PEERS_SEARCH_LABEL = "NAICS_PEERS_SEARCH_LABEL";
export const NAICS_PEERS_NO_PEERS = "NAICS_PEERS_NO_PEERS";

export const INDUSTRY_CLASS_PEERS_INPUT_LABEL =
  "INDUSTRY_CLASS_PEERS_INPUT_LABEL";
export const INDUSTRY_CLASS_PEERS_TITLE = "INDUSTRY_CLASS_PEERS_TITLE";
export const INDUSTRY_CLASS_PEERS_SUBTITLE = "INDUSTRY_CLASS_PEERS_SUBTITLE";
export const INDUSTRY_CLASS_PEERS_NO_PEERS = "INDUSTRY_CLASS_PEERS_NO_PEERS";

export const REVIEW_PEER_COMPARISON_TITLE = "REVIEW_PEER_COMPARISON_TITLE";
export const REVIEW_PEER_COMPARISON_SUBTITLE =
  "REVIEW_PEER_COMPARISON_SUBTITLE";
export const REVIEW_EXPOSURE_METRICS_TITLE = "REVIEW_EXPOSURE_METRICS_TITLE";
export const REVIEW_EXPOSURE_METRICS_SUBTITLE =
  "REVIEW_EXPOSURE_METRICS_SUBTITLE";
export const REVIEW_ADD_PEERS_TITLE = "REVIEW_ADD_PEERS_TITLE";
export const REVIEW_ADD_PEERS_SUBTITLE = "REVIEW_ADD_PEERS_SUBTITLE";
export const REVIEW_REFRESH_PEERS_TO_CURRENT_YEAR =
  "REVIEW_REFRESH_PEERS_TO_CURRENT_YEAR";

export const INCLUDED_LOSS_TYPES_TITLE = "INCLUDED_LOSS_TYPES_TITLE";
export const INCLUDED_LOSS_TYPES_SUBTITLE = "INCLUDED_LOSS_TYPES_SUBTITLE";
export const INCLUDED_LOSS_TYPES_SWITCH_LABEL =
  "INCLUDED_LOSS_TYPES_SWITCH_LABEL";
export const INCLUDED_LOSS_TYPES_NO_FILTER_MESSAGE =
  "INCLUDED_LOSS_TYPES_NO_FILTER_MESSAGE";

export const MODEL_SETTINGS_TITLE = "MODEL_SETTINGS_TITLE";
export const MODEL_SETTINGS_SUBTITLE = "MODEL_SETTINGS_SUBTITLE";
export const MODEL_SETTINGS_START_DATE_LABEL =
  "MODEL_SETTINGS_START_DATE_LABEL";
export const MODEL_SETTINGS_END_DATE_LABEL = "MODEL_SETTINGS_END_DATE_LABEL";

export const RENEWAL_COMPONENT_TITLE = "RENEWAL_COMPONENT_TITLE";
export const RENEWAL_NO_PRIOR_SUBMISSION = "RENEWAL_NO_PRIOR_SUBMISSION";
export const RENEWAL_SELECT_PRIOR_SUBMISSION =
  "RENEWAL_SELECT_PRIOR_SUBMISSION";

// Renewal menu and actions
export const RENEW_MENU_RENEW_BUTTON = "RENEW_MENU_RENEW_BUTTON";
export const RENEW_MENU_FETCH_ERROR = "RENEW_MENU_FETCH_ERROR";
export const RENEW_MENU_RETRY_BUTTON = "RENEW_MENU_RETRY_BUTTON";
export const RENEW_BUTTON_TOOLTIP = "RENEW_BUTTON_TOOLTIP";

// Search and filters
export const SEARCH_FILTER_RENEWING_SOON = "SEARCH_FILTER_RENEWING_SOON";
export const RENEWAL_FILTER_ANYTIME = "RENEWAL_FILTER_ANYTIME";

// Program and submission confirmations
export const PROGRAM_TRANSACTION_NEW_BUSINESS =
  "PROGRAM_TRANSACTION_NEW_BUSINESS";
export const PROGRAM_TRANSACTION_RENEWAL = "PROGRAM_TRANSACTION_RENEWAL";
export const PROGRAM_TRANSACTION_MTA = "PROGRAM_TRANSACTION_MTA";
export const PROGRAM_TRANSACTION_CANCELLATION =
  "PROGRAM_TRANSACTION_CANCELLATION";
export const PROGRAM_TRANSACTION_ALT_OPTION = "PROGRAM_TRANSACTION_ALT_OPTION";
export const PROGRAM_TRANSACTION_REWRITE = "PROGRAM_TRANSACTION_REWRITE";
export const SUBMISSION_RENEW_CONFIRM_TITLE = "SUBMISSION_RENEW_CONFIRM_TITLE";
export const SUBMISSION_RENEW_CONFIRM_ACTION =
  "SUBMISSION_RENEW_CONFIRM_ACTION";

// Summary notes
export const SUMMARY_NOTES_CONSIDERATIONS_FROM_LAST_RENEWAL =
  "SUMMARY_NOTES_CONSIDERATIONS_FROM_LAST_RENEWAL";
export const SUMMARY_NOTES_CONSIDERATIONS_FOR_NEXT_RENEWAL =
  "SUMMARY_NOTES_CONSIDERATIONS_FOR_NEXT_RENEWAL";

export const PRIMARY_EXPOSURE_TITLE = "PRIMARY_EXPOSURE_TITLE";
export const PRIMARY_EXPOSURE_SUBTITLE = "PRIMARY_EXPOSURE_SUBTITLE";
export const PRIMARY_EXPOSURE_LABEL = "PRIMARY_EXPOSURE_LABEL";
export const PRIMARY_EXPOSURE_BLANK_CHART_MESSAGE =
  "PRIMARY_EXPOSURE_BLANK_CHART_MESSAGE";

export const PRINT_META_REF = "PRINT_META_REF";
export const PRINT_META_INCEPTION = "PRINT_META_INCEPTION";
export const PRINT_META_RENEWAL = "PRINT_META_RENEWAL";
export const PRINT_META_INDUSTRY_CLASS = "PRINT_META_INDUSTRY_CLASS";
export const PRINT_META_UW = "PRINT_META_UW";
export const PRINT_META_BROKERAGE = "PRINT_META_BROKERAGE";
export const PRINT_META_BROKER = "PRINT_META_BROKER";
export const PRINT_META_BROKER_ADDRESS = "PRINT_META_BROKER_ADDRESS";
export const PRINT_META_INSURED_ADDRESS = "PRINT_META_INSURED_ADDRESS";

export const PRINT_RISK_SUMMARY_TITLE = "PRINT_RISK_SUMMARY_TITLE";

export const PRINT_ITD_GWP = "PRINT_ITD_GWP";
export const PRINT_GWP_ERROR_LOADING_DATA = "PRINT_GWP_ERROR_LOADING_DATA";

export const PRINT_EXPOSURE_FLAGS_TITLE = "PRINT_EXPOSURE_FLAGS_TITLE";
export const PRINT_TOWER = "PRINT_TOWER";
export const PRINT_TOWER_PRICING_AGENCY_LIMIT =
  "PRINT_TOWER_PRICING_AGENCY_LIMIT";
export const PRINT_TOWER_PRICING_WHOLE_LAYER_LIMIT =
  "PRINT_TOWER_PRICING_WHOLE_LAYER_LIMIT";
export const PRINT_TOWER_PRICING_ATTACHMENT_POINT =
  "PRINT_TOWER_PRICING_ATTACHMENT_POINT";
export const PRINT_TOWER_PRICING_AGENCY_PREMIUM =
  "PRINT_TOWER_PRICING_AGENCY_PREMIUM";
export const PRINT_TOWER_PRICING_PUNI_PREMIUM =
  "PRINT_TOWER_PRICING_PUNI_PREMIUM";
export const PRINT_TOWER_PRICING_PREMIUM_EX_PUNI =
  "PRINT_TOWER_PRICING_PREMIUM_EX_PUNI";
export const PRINT_STRUCTURE = "PRINT_STRUCTURE";
export const PRINT_CURRENT_EXPOSURES = "PRINT_CURRENT_EXPOSURES";
export const PRINT_RECENT_EXPOSURES = "PRINT_RECENT_EXPOSURES";

export const AGGREGATED_CLAIMS_TABLE_TITLE = "AGGREGATED_CLAIMS_TABLE_TITLE";

export const TEMPLATES_TITLE = "TEMPLATES_TITLE";
export const TEMPLATES_FILL_TEMPLATE_LABEL = "TEMPLATES_FILL_TEMPLATE_LABEL";

export const TERMS_AND_CONDITIONS_TITLE = "TERMS_AND_CONDITIONS_TITLE";
export const TERMS_AND_CONDITIONS_SUBTITLE = "TERMS_AND_CONDITIONS_SUBTITLE";
export const TERMS_AND_CONDITIONS_ADD_CUSTOM_TOOLTIP =
  "TERMS_AND_CONDITIONS_ADD_CUSTOM_TOOLTIP";
export const TERMS_AND_CONDITIONS_AVAILABLE_TITLE =
  "TERMS_AND_CONDITIONS_AVAILABLE_TITLE";
export const TERMS_AND_CONDITIONS_STANDARD_LABEL =
  "TERMS_AND_CONDITIONS_STANDARD_LABEL";

export const SUBJECTIVITIES_TITLE = "SUBJECTIVITIES_TITLE";
export const SUBJECTIVITIES_SUBTITLE = "SUBJECTIVITIES_SUBTITLE";
export const SUBJECTIVITIES_ADD_CUSTOM_TOOLTIP =
  "SUBJECTIVITIES_ADD_CUSTOM_TOOLTIP";
export const SUBJECTIVITIES_AVAILABLE_TITLE = "SUBJECTIVITIES_AVAILABLE_TITLE";
export const SUBJECTIVITIES_STANDARD_LABEL = "SUBJECTIVITIES_STANDARD_LABEL";
export const SUBJECTIVITIES_FULFILLED_LABEL = "SUBJECTIVITIES_FULFILLED_LABEL";

export const SPECIAL_CONDITIONS_TITLE = "SPECIAL_CONDITIONS_TITLE";
export const SPECIAL_CONDITIONS_SUBTITLE = "SPECIAL_CONDITIONS_SUBTITLE";
export const SPECIAL_CONDITIONS_ADD_CUSTOM_TOOLTIP =
  "SPECIAL_CONDITIONS_ADD_CUSTOM_TOOLTIP";
export const SPECIAL_CONDITIONS_AVAILABLE_TITLE =
  "SPECIAL_CONDITIONS_AVAILABLE_TITLE";
export const SPECIAL_CONDITIONS_STANDARD_LABEL =
  "SPECIAL_CONDITIONS_STANDARD_LABEL";

export const POLICY_TYPE_RETRO_DATE_LABEL = "POLICY_TYPE_RETRO_DATE_LABEL";

export const PRICING_RESULTS_TITLE_PREFIX = "PRICING_RESULTS_TITLE_PREFIX";

export const TOWER_PRICING_TOWER_LAYERS_TITLE =
  "TOWER_PRICING_TOWER_LAYERS_TITLE";
export const TOWER_PRICING_TOWER_LAYERS_SUBTITLE =
  "TOWER_PRICING_TOWER_LAYERS_SUBTITLE";

export const LAYER_PRICING_LAYER_SELECTOR_TITLE =
  "LAYER_PRICING_LAYER_SELECTOR_TITLE";
export const LAYER_PRICING_UW_JUDGMENTS_ALERT =
  "LAYER_PRICING_UW_JUDGMENTS_ALERT";

// DNF Layer Pricing Table Column Labels
export const LAYER_PRICING_TABLE_PAPER_PROVIDER_LABEL =
  "LAYER_PRICING_TABLE_PAPER_PROVIDER_LABEL";
export const LAYER_PRICING_TABLE_FOLLOWED_POLICY_LABEL =
  "LAYER_PRICING_TABLE_FOLLOWED_POLICY_LABEL";
export const LAYER_PRICING_TABLE_RPI_LABEL = "LAYER_PRICING_TABLE_RPI_LABEL";
export const LAYER_PRICING_TABLE_CAT_MODEL_LABEL =
  "LAYER_PRICING_TABLE_CAT_MODEL_LABEL";
export const LAYER_PRICING_TABLE_NON_CAT_SCALE_LABEL =
  "LAYER_PRICING_TABLE_NON_CAT_SCALE_LABEL";
export const LAYER_PRICING_TABLE_NON_CAT_TECHNICAL_LABEL =
  "LAYER_PRICING_TABLE_NON_CAT_TECHNICAL_LABEL";
export const LAYER_PRICING_TABLE_CAT_SCALE_LABEL =
  "LAYER_PRICING_TABLE_CAT_SCALE_LABEL";
export const LAYER_PRICING_TABLE_CAT_TECHNICAL_LABEL =
  "LAYER_PRICING_TABLE_CAT_TECHNICAL_LABEL";
export const LAYER_PRICING_TABLE_TECHNICAL_PREMIUM_LABEL =
  "LAYER_PRICING_TABLE_TECHNICAL_PREMIUM_LABEL";
export const LAYER_PRICING_TABLE_ROL_LABEL = "LAYER_PRICING_TABLE_ROL_LABEL";
export const LAYER_PRICING_TABLE_BROKER_TARGET_LABEL =
  "LAYER_PRICING_TABLE_BROKER_TARGET_LABEL";
export const LAYER_PRICING_TABLE_BROKER_TARGET_ROL_LABEL =
  "LAYER_PRICING_TABLE_BROKER_TARGET_ROL_LABEL";
export const LAYER_PRICING_TABLE_HELIX_QUOTE_LABEL =
  "LAYER_PRICING_TABLE_HELIX_QUOTE_LABEL";
export const LAYER_PRICING_TABLE_HELIX_QUOTE_ROL_LABEL =
  "LAYER_PRICING_TABLE_HELIX_QUOTE_ROL_LABEL";
export const LAYER_PRICING_TABLE_FOT_LABEL = "LAYER_PRICING_TABLE_FOT_LABEL";
export const LAYER_PRICING_TABLE_FOT_ROL_LABEL =
  "LAYER_PRICING_TABLE_FOT_ROL_LABEL";
export const LAYER_PRICING_TABLE_GROSS_LR_OF_TECHNICAL_PREMIUM_LABEL =
  "LAYER_PRICING_TABLE_GROSS_LR_OF_TECHNICAL_PREMIUM_LABEL";
export const LAYER_PRICING_TABLE_HELIX_QUOTE_AS_PCT_OF_TECHNICAL_LABEL =
  "LAYER_PRICING_TABLE_HELIX_QUOTE_AS_PCT_OF_TECHNICAL_LABEL";
export const LAYER_PRICING_TABLE_FOT_AS_PCT_OF_TECHNICAL_LABEL =
  "LAYER_PRICING_TABLE_FOT_AS_PCT_OF_TECHNICAL_LABEL";
export const LAYER_PRICING_TABLE_GROSS_GROSS_LOSS_RATIO_QUOTE_LABEL =
  "LAYER_PRICING_TABLE_GROSS_GROSS_LOSS_RATIO_QUOTE_LABEL";
export const LAYER_PRICING_TABLE_GROSS_GROSS_LOSS_RATIO_FOT_LABEL =
  "LAYER_PRICING_TABLE_GROSS_GROSS_LOSS_RATIO_FOT_LABEL";
export const LAYER_PRICING_TABLE_COMBINED_UW_RATIO_QUOTE_LABEL =
  "LAYER_PRICING_TABLE_COMBINED_UW_RATIO_QUOTE_LABEL";
export const LAYER_PRICING_TABLE_COMBINED_UW_RATIO_FOT_LABEL =
  "LAYER_PRICING_TABLE_COMBINED_UW_RATIO_FOT_LABEL";
export const LAYER_PRICING_TABLE_EXPOSURE_LINE_OUR_SHARE_QUOTE_LABEL =
  "LAYER_PRICING_TABLE_EXPOSURE_LINE_OUR_SHARE_QUOTE_LABEL";
export const LAYER_PRICING_TABLE_EXPOSURE_LINE_OUR_SHARE_FOT_LABEL =
  "LAYER_PRICING_TABLE_EXPOSURE_LINE_OUR_SHARE_FOT_LABEL";
export const LAYER_PRICING_TABLE_GROSS_PREMIUM_OUR_SHARE_QUOTE_LABEL =
  "LAYER_PRICING_TABLE_GROSS_PREMIUM_OUR_SHARE_QUOTE_LABEL";
export const LAYER_PRICING_TABLE_GROSS_PREMIUM_OUR_SHARE_FOT_LABEL =
  "LAYER_PRICING_TABLE_GROSS_PREMIUM_OUR_SHARE_FOT_LABEL";
export const LAYER_PRICING_TABLE_TRIA_STATUS_LABEL =
  "LAYER_PRICING_TABLE_TRIA_STATUS_LABEL";
export const LAYER_PRICING_TABLE_TRIA_PCT_LABEL =
  "LAYER_PRICING_TABLE_TRIA_PCT_LABEL";
export const LAYER_PRICING_TABLE_TRIA_AMOUNT_LABEL =
  "LAYER_PRICING_TABLE_TRIA_AMOUNT_LABEL";
export const LAYER_PRICING_TABLE_PERILS_LABEL =
  "LAYER_PRICING_TABLE_PERILS_LABEL";
export const LAYER_PRICING_TABLE_CAT_SPLIT_NO_MODEL_DATA_ERROR =
  "LAYER_PRICING_TABLE_CAT_SPLIT_NO_MODEL_DATA_ERROR";

export const RATE_CHANGE_CURRENT_LAYER_SELECTOR_TITLE =
  "RATE_CHANGE_CURRENT_LAYER_SELECTOR_TITLE";
export const RATE_CHANGE_CURRENT_LAYER_SELECTOR_SUBTITLE =
  "RATE_CHANGE_CURRENT_LAYER_SELECTOR_SUBTITLE";
export const RATE_CHANGE_PRIOR_LAYER_SELECTOR_SUBTITLE =
  "RATE_CHANGE_PRIOR_LAYER_SELECTOR_SUBTITLE";
export const RATE_CHANGE_PRIOR_LAYER_SELECTOR_TITLE =
  "RATE_CHANGE_PRIOR_LAYER_SELECTOR_TITLE";
export const RATE_CHANGE_COMPONENT_SELECTOR_TITLE =
  "RATE_CHANGE_COMPONENT_SELECTOR_TITLE";
export const RATE_CHANGE_COMPONENT_SELECTOR_SUBTITLE =
  "RATE_CHANGE_COMPONENT_SELECTOR_SUBTITLE";
export const RATE_CHANGE_JUSTIFICATION_TITLE =
  "RATE_CHANGE_JUSTIFICATION_TITLE";
export const RATE_CHANGE_COMPONENT_SELECTOR_STRUCTURE =
  "RATE_CHANGE_COMPONENT_SELECTOR_STRUCTURE";
export const RATE_CHANGE_COMPONENT_SELECTOR_COMMISSION =
  "RATE_CHANGE_COMPONENT_SELECTOR_COMMISSION";
export const RATE_CHANGE_COMPONENT_SELECTOR_EXPOSURE =
  "RATE_CHANGE_COMPONENT_SELECTOR_EXPOSURE";
export const RATE_CHANGE_COMPONENT_SELECTOR_UW_JUDGMENT =
  "RATE_CHANGE_COMPONENT_SELECTOR_UW_JUDGMENT";
export const RATE_CHANGE_COMPONENT_SELECTOR_INFLATION =
  "RATE_CHANGE_COMPONENT_SELECTOR_INFLATION";
export const RATE_CHANGE_WATERFALL_CHART_TITLE =
  "RATE_CHANGE_WATERFALL_CHART_TITLE";
export const RATE_CHANGE_MIGRATE_TO_DEFAULTS_TITLE =
  "RATE_CHANGE_MIGRATE_TO_DEFAULTS_TITLE";
export const RATE_CHANGE_MIGRATE_TO_DEFAULTS_DESCRIPTION =
  "RATE_CHANGE_MIGRATE_TO_DEFAULTS_DESCRIPTION";
export const RATE_CHANGE_MIGRATE_TO_DEFAULTS_BUTTON =
  "RATE_CHANGE_MIGRATE_TO_DEFAULTS_BUTTON";
export const RATE_CHANGE_WATERFALL_CHART_CALCULATE_BUTTON =
  "RATE_CHANGE_WATERFALL_CHART_CALCULATE_BUTTON";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_PRIOR_COMMISSION =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_PRIOR_COMMISSION";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_CURRENT_COMMISSION =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_CURRENT_COMMISSION";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_DAYS_ON_RISK =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_DAYS_ON_RISK";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_PRO_RATA =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_PRO_RATA";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_TOTAL_OVERRIDE =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_TOTAL_OVERRIDE";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_PRIOR =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_PRIOR";
export const RATE_CHANGE_WATERFALL_CHART_TOOLTIP_CURRENT =
  "RATE_CHANGE_WATERFALL_CHART_TOOLTIP_CURRENT";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_TITLE =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_TITLE";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_SUBTITLE =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_SUBTITLE";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_USE_RENEWED =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_USE_RENEWED";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_MEASURE =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_MEASURE";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_UNIT =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_UNIT";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_RENEWED_PREFIX =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_RENEWED_PREFIX";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_EXPIRED_PREFIX =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_EXPIRED_PREFIX";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_RATE_IMPACT_OVERRIDE =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_RATE_IMPACT_OVERRIDE";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_TOTAL =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_TOTAL";
export const RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_TOTAL_UNIT =
  "RATE_CHANGE_YEAR_ON_YEAR_EXPOSURES_TOTAL_UNIT";
export const RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_TITLE =
  "RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_TITLE";
export const RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_SUBTITLE =
  "RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_SUBTITLE";
export const RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_CURRENT =
  "RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_CURRENT";
export const RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_PRIOR =
  "RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_PRIOR";
export const RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_CLEAR_ZOOM =
  "RATE_CHANGE_SIDE_BY_SIDE_CLAIMS_CHART_CLEAR_ZOOM";
export const RATE_CHANGE_INFLATION_SELECTOR_TITLE =
  "RATE_CHANGE_INFLATION_SELECTOR_TITLE";
export const RATE_CHANGE_INFLATION_SELECTOR_LABEL =
  "RATE_CHANGE_INFLATION_SELECTOR_LABEL";
export const RATE_CHANGE_REBASE_SELECTOR_TITLE =
  "RATE_CHANGE_REBASE_SELECTOR_TITLE";
export const RATE_CHANGE_REBASE_SELECTOR_SUBTITLE =
  "RATE_CHANGE_REBASE_SELECTOR_SUBTITLE";
export const STATUS_QUICK_SWITCH_TOOLTIP = "STATUS_QUICK_SWITCH_TOOLTIP";
export const STATUS_REASON_LABEL = "STATUS_REASON_LABEL";
export const PROGRAM_STATUS_REASON_LABEL = "PROGRAM_STATUS_REASON_LABEL";
export const PEER_COMPARISON_TOWER_RATE_CHART_TITLE =
  "PEER_COMPARISON_TOWER_RATE_CHART_TITLE";
export const PEER_COMPARISON_TOWER_RATE_CHART_SUBTITLE =
  "PEER_COMPARISON_TOWER_RATE_CHART_SUBTITLE";
export const PEER_COMPARISON_TOWER_RATE_CHART_Y_LABEL =
  "PEER_COMPARISON_TOWER_RATE_CHART_Y_LABEL";
export const PEER_COMPARISON_TOWER_RATE_CHART_X_LABEL =
  "PEER_COMPARISON_TOWER_RATE_CHART_X_LABEL";

export const PEER_RATE_CHART_TOWER_BUTTON = "PEER_RATE_CHART_TOWER_BUTTON";
export const PEER_RATE_CHART_PRICING_BUTTON = "PEER_RATE_CHART_PRICING_BUTTON";
export const PEER_RATE_CHART_TOWER_TOOLTIP = "PEER_RATE_CHART_TOWER_TOOLTIP";
export const PEER_RATE_CHART_PRICING_TOOLTIP =
  "PEER_RATE_CHART_PRICING_TOOLTIP";

export const STATE_SUMMARY_RESET_TO_V1_BUCKETS =
  "STATE_SUMMARY_RESET_TO_V1_BUCKETS";
export const STATE_SUMMARY_RESET_TO_V2_BUCKETS =
  "STATE_SUMMARY_RESET_TO_V2_BUCKETS";
export const CLAIMS_CHART_TOO_MANY_CLAIMS = "CLAIMS_CHART_TOO_MANY_CLAIMS";
export const CLAIMS_CHART_SET_TO_BUTTON = "CLAIMS_CHART_SET_TO_BUTTON";

export const BROKER_TOWER_TITLE = "BROKER_TOWER_TITLE";
export const BROKER_TOWER_SUBTITLE = "BROKER_TOWER_SUBTITLE";
export const BROKER_TOWER_NOTES_TITLE = "BROKER_TOWER_NOTES_TITLE";

export const LOSS_DEVELOPMENT_NOTES_TITLE = "LOSS_DEVELOPMENT_NOTES_TITLE";
export const LOSS_DEVELOPMENT_INITIAL_EXPECTED_LOSS_RATIO =
  "LOSS_DEVELOPMENT_INITIAL_EXPECTED_LOSS_RATIO";

export const FORESTRY_LAYER_PRICING_EXCLUDING_LABEL =
  "FORESTRY_LAYER_PRICING_EXCLUDING_LABEL";
export const FORESTRY_LAYER_PRICING_PAPER_PROVIDER_LABEL =
  "FORESTRY_LAYER_PRICING_PAPER_PROVIDER_LABEL";
export const FORESTRY_LAYER_PRICING_TECHNICAL_LABEL =
  "FORESTRY_LAYER_PRICING_TECHNICAL_LABEL";
export const FORESTRY_LAYER_PRICING_NET_ADEQUATE_LABEL =
  "FORESTRY_LAYER_PRICING_NET_ADEQUATE_LABEL";
export const FORESTRY_LAYER_PRICING_GROSS_ACTUAL_LABEL =
  "FORESTRY_LAYER_PRICING_GROSS_ACTUAL_LABEL";
export const FORESTRY_LAYER_PRICING_ROL_LABEL =
  "FORESTRY_LAYER_PRICING_ROL_LABEL";
export const FORESTRY_LAYER_PRICING_MARGINAL_LOSS_RATIO_LABEL =
  "FORESTRY_LAYER_PRICING_MARGINAL_LOSS_RATIO_LABEL";
export const FORESTRY_LAYER_PRICING_BROKER_TARGET_LABEL =
  "FORESTRY_LAYER_PRICING_BROKER_TARGET_LABEL";
export const FORESTRY_LAYER_PRICING_BROKER_GROSS_RATE_LABEL =
  "FORESTRY_LAYER_PRICING_BROKER_GROSS_RATE_LABEL";
export const FORESTRY_LAYER_PRICING_BROKER_ACTUAL_GROSS_RATE_LABEL =
  "FORESTRY_LAYER_PRICING_BROKER_ACTUAL_GROSS_RATE_LABEL";
export const FORESTRY_LAYER_PRICING_BROKER_ADEQUACY_LABEL =
  "FORESTRY_LAYER_PRICING_BROKER_ADEQUACY_LABEL";
export const FORESTRY_LAYER_PRICING_ROL_TARGET_LABEL =
  "FORESTRY_LAYER_PRICING_ROL_TARGET_LABEL";
export const FORESTRY_LAYER_PRICING_OUR_QUOTE_LABEL =
  "FORESTRY_LAYER_PRICING_OUR_QUOTE_LABEL";
export const FORESTRY_LAYER_PRICING_BROKERAGE_LABEL =
  "FORESTRY_LAYER_PRICING_BROKERAGE_LABEL";
export const FORESTRY_LAYER_PRICING_OUR_QUOTE_NET_LABEL =
  "FORESTRY_LAYER_PRICING_OUR_QUOTE_NET_LABEL";
export const FORESTRY_LAYER_PRICING_OUR_QUOTE_GROSS_RATE_LABEL =
  "FORESTRY_LAYER_PRICING_OUR_QUOTE_GROSS_RATE_LABEL";
export const FORESTRY_LAYER_PRICING_QUOTE_ACTUAL_GROSS_RATE_LABEL =
  "FORESTRY_LAYER_PRICING_QUOTE_ACTUAL_GROSS_RATE_LABEL";
export const FORESTRY_LAYER_PRICING_QUOTE_ADEQUACY_LABEL =
  "FORESTRY_LAYER_PRICING_QUOTE_ADEQUACY_LABEL";
export const FORESTRY_LAYER_PRICING_OUR_QUOTE_ROL_LABEL =
  "FORESTRY_LAYER_PRICING_OUR_QUOTE_ROL_LABEL";
export const FORESTRY_LAYER_PRICING_FOT_LABEL =
  "FORESTRY_LAYER_PRICING_FOT_LABEL";
export const FORESTRY_LAYER_PRICING_FOT_NET_LABEL =
  "FORESTRY_LAYER_PRICING_FOT_NET_LABEL";
export const FORESTRY_LAYER_PRICING_FOT_GROSS_RATE_LABEL =
  "FORESTRY_LAYER_PRICING_FOT_GROSS_RATE_LABEL";
export const FORESTRY_LAYER_PRICING_FOT_ROL_LABEL =
  "FORESTRY_LAYER_PRICING_FOT_ROL_LABEL";
export const FORESTRY_LAYER_PRICING_TOTAL_EXPECTED_LOSS_LABEL =
  "FORESTRY_LAYER_PRICING_TOTAL_EXPECTED_LOSS_LABEL";
export const FORESTRY_LAYER_PRICING_LIMIT_LOAD_LABEL =
  "FORESTRY_LAYER_PRICING_LIMIT_LOAD_LABEL";
export const FORESTRY_LAYER_PRICING_DEDUCTIBLE_LOAD_LABEL =
  "FORESTRY_LAYER_PRICING_DEDUCTIBLE_LOAD_LABEL";
export const FORESTRY_LAYER_PRICING_RATE_LABEL =
  "FORESTRY_LAYER_PRICING_RATE_LABEL";
export const FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_LOADING_MESSAGE =
  "FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_LOADING_MESSAGE";
export const FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_NO_SOV_MESSAGE =
  "FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_NO_SOV_MESSAGE";
export const FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_NO_ATTACHMENT_MESSAGE =
  "FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_NO_ATTACHMENT_MESSAGE";
export const FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_PREFIX_MESSAGE =
  "FORESTRY_LAYER_PRICING_MAX_TIV_PERCENTAGE_PREFIX_MESSAGE";
export const FORESTRY_LAYER_PRICING_TITLE = "FORESTRY_LAYER_PRICING_TITLE";
export const FORESTRY_LAYER_PRICING_CALCULATE_BUTTON_MESSAGE =
  "FORESTRY_LAYER_PRICING_CALCULATE_BUTTON_MESSAGE";
export const FORESTRY_LAYER_PRICING_PERILS_LABEL =
  "FORESTRY_LAYER_PRICING_PERILS_LABEL";

export const AUTO_LAYER_PRICING_EXCLUDING_LABEL =
  "AUTO_LAYER_PRICING_EXCLUDING_LABEL";
export const AUTO_LAYER_PRICING_PAPER_PROVIDER_LABEL =
  "AUTO_LAYER_PRICING_PAPER_PROVIDER_LABEL";
export const AUTO_LAYER_PRICING_LAYER_PREMIUM_LABEL =
  "AUTO_LAYER_PRICING_LAYER_PREMIUM_LABEL";
export const AUTO_LAYER_PRICING_ROL_LABEL = "AUTO_LAYER_PRICING_ROL_LABEL";
export const AUTO_LAYER_PRICING_BROKER_TARGET_LABEL =
  "AUTO_LAYER_PRICING_BROKER_TARGET_LABEL";
export const AUTO_LAYER_PRICING_ROL_TARGET_LABEL =
  "AUTO_LAYER_PRICING_ROL_TARGET_LABEL";
export const AUTO_LAYER_PRICING_OUR_QUOTE_LABEL =
  "AUTO_LAYER_PRICING_OUR_QUOTE_LABEL";
export const AUTO_LAYER_PRICING_OUR_QUOTE_ROL_LABEL =
  "AUTO_LAYER_PRICING_OUR_QUOTE_ROL_LABEL";
export const AUTO_LAYER_PRICING_FOT_LABEL = "AUTO_LAYER_PRICING_FOT_LABEL";
export const AUTO_LAYER_PRICING_FOT_ROL_LABEL =
  "AUTO_LAYER_PRICING_FOT_ROL_LABEL";
export const AUTO_LAYER_PRICING_GU_PREMIUM_LABEL =
  "AUTO_LAYER_PRICING_GU_PREMIUM_LABEL";
export const AUTO_LAYER_PRICING_ILF_FACTOR_LABEL =
  "AUTO_LAYER_PRICING_ILF_FACTOR_LABEL";
export const AUTO_LAYER_PRICING_TITLE = "AUTO_LAYER_PRICING_TITLE";
export const AUTO_LAYER_PRICING_CALCULATE_BUTTON_MESSAGE =
  "AUTO_LAYER_PRICING_CALCULATE_BUTTON_MESSAGE";

export const TOWER_SHARE_TABLE_CARRIER = "TOWER_SHARE_TABLE_CARRIER";
export const TOWER_SHARE_TABLE_SHARE_OF_LIMIT =
  "TOWER_SHARE_TABLE_SHARE_OF_LIMIT";
export const TOWER_SHARE_TABLE_SHARE = "TOWER_SHARE_TABLE_SHARE";
export const TOWER_SHARE_TABLE_SHARE_OF_GWP = "TOWER_SHARE_TABLE_SHARE_OF_GWP";
export const TOWER_SHARE_TABLE_BROKERAGE = "TOWER_SHARE_TABLE_BROKERAGE";
export const TOWER_SHARE_TABLE_GROSS_RPM = "TOWER_SHARE_TABLE_GROSS_RPM";
export const TOWER_SHARE_TABLE_SHARE_OF_NWP = "TOWER_SHARE_TABLE_SHARE_OF_NWP";
export const TOWER_SHARE_TABLE_RETRO_DATE = "TOWER_SHARE_TABLE_RETRO_DATE";
export const TOWER_SHARE_TABLE_COMMENTS = "TOWER_SHARE_TABLE_COMMENTS";
export const TOWER_SHARE_TABLE_REFERENCE = "TOWER_SHARE_TABLE_REFERENCE";
export const TOWER_SHARE_TABLE_COVERAGE = "TOWER_SHARE_TABLE_COVERAGE";
export const TOWER_SHARE_TABLE_POLICY_FORM = "TOWER_SHARE_TABLE_POLICY_FORM";
export const TOWER_SHARE_TABLE_AGGREGATE_LIMIT =
  "TOWER_SHARE_TABLE_AGGREGATE_LIMIT";
export const TOWER_SHARE_TABLE_PL_AGGREGATE_LIMIT =
  "TOWER_SHARE_TABLE_PL_AGGREGATE_LIMIT";
export const SOV_DOWNLOAD_TEMPLATE_BUTTON = "SOV_DOWNLOAD_TEMPLATE_BUTTON";
export const SOV_TEMPLATE_DOWNLOAD_SUCCESS = "SOV_TEMPLATE_DOWNLOAD_SUCCESS";
export const SOV_TEMPLATE_DOWNLOAD_FAILURE = "SOV_TEMPLATE_DOWNLOAD_FAILURE";
export const SUBMISSION_LIST_CREATE_RENEWAL_BUTTON =
  "SUBMISSION_LIST_CREATE_RENEWAL_BUTTON";
export const REVIEW_REPORT_INCLUDE_NON_RENEWING =
  "REVIEW_REPORT_INCLUDE_NON_RENEWING";
export const PRO_RATA_CALC_TITLE = "PRO_RATA_CALC_TITLE";
export const PRO_RATA_CALC_POLICY_INFORMATION =
  "PRO_RATA_CALC_POLICY_INFORMATION";
export const PRO_RATA_CALC_TOTAL_PREMIUM = "PRO_RATA_CALC_TOTAL_PREMIUM";
export const PRO_RATA_CALC_INCEPTION_DATE = "PRO_RATA_CALC_INCEPTION_DATE";
export const PRO_RATA_CALC_EXPIRY_DATE = "PRO_RATA_CALC_EXPIRY_DATE";
export const PRO_RATA_CALC_NEW_CLOSE_DATE = "PRO_RATA_CALC_NEW_CLOSE_DATE";
export const PRO_RATA_CALC_POLICY_PERIOD = "PRO_RATA_CALC_POLICY_PERIOD";
export const PRO_RATA_CALC_TOTAL_POLICY_DAYS =
  "PRO_RATA_CALC_TOTAL_POLICY_DAYS";
export const PRO_RATA_CALC_UPDATED_POLICY_DAYS =
  "PRO_RATA_CALC_UPDATED_POLICY_DAYS";
export const PRO_RATA_CALC_ADDITIONAL_TITLE = "PRO_RATA_CALC_ADDITIONAL_TITLE";
export const PRO_RATA_CALC_RETURNED_TITLE = "PRO_RATA_CALC_RETURNED_TITLE";
export const PRO_RATA_CALC_PREMIUM_INCREASED =
  "PRO_RATA_CALC_PREMIUM_INCREASED";
export const PRO_RATA_CALC_PREMIUM_REDUCED = "PRO_RATA_CALC_PREMIUM_REDUCED";
export const PRO_RATA_CALC_PREMIUM_TITLE = "PRO_RATA_CALC_PREMIUM_TITLE";
export const PRO_RATA_CALC_FACTOR_TITLE = "PRO_RATA_CALC_FACTOR_TITLE";
export const PRO_RATA_CALC_FACTOR_REDUCTION = "PRO_RATA_CALC_FACTOR_REDUCTION";
export const PRO_RATA_CALC_FACTOR_ADDITION = "PRO_RATA_CALC_FACTOR_ADDITION";
export const PRO_RATA_CALC_FACTOR_REMAINING = "PRO_RATA_CALC_FACTOR_REMAINING";
export const PRO_RATA_CALC_DAYS_EXTENDED = "PRO_RATA_CALC_DAYS_EXTENDED";
export const PRO_RATA_CALC_DAYS_REDUCED = "PRO_RATA_CALC_DAYS_REDUCED";
export const PRO_RATA_CALC_TOTAL_NEW_PREMIUM =
  "PRO_RATA_CALC_TOTAL_NEW_PREMIUM";
export const PREM_ADJ_EDITOR_PRO_RATA_BUTTON =
  "PREM_ADJ_EDITOR_PRO_RATA_BUTTON";
export const PREM_ADJ_EDITOR_CUSTOM_OVERRIDES_WARNING =
  "PREM_ADJ_EDITOR_CUSTOM_OVERRIDES_WARNING";
export const PREM_ADJ_EDITOR_DELETE_OVERRIDES_BUTTON =
  "PREM_ADJ_EDITOR_DELETE_OVERRIDES_BUTTON";
export const PREM_ADJ_EDITOR_ADDITIONAL_PREMIUM_TEXT =
  "PREM_ADJ_EDITOR_ADDITIONAL_PREMIUM_TEXT";
export const PREM_ADJ_EDITOR_RETURNED_PREMIUM_TEXT =
  "PREM_ADJ_EDITOR_RETURNED_PREMIUM_TEXT";
export const PREM_ADJ_EDITOR_PREMIUM_INSTALLMENT_TEXT =
  "PREM_ADJ_EDITOR_PREMIUM_INSTALLMENT_TEXT";
export const PREM_ADJ_EDITOR_NOT_SET_TEXT = "PREM_ADJ_EDITOR_NOT_SET_TEXT";
export const PREM_ADJ_EDITOR_START_DATE = "PREM_ADJ_EDITOR_START_DATE";
export const PREM_ADJ_EDITOR_END_DATE = "PREM_ADJ_EDITOR_END_DATE";
export const PREM_ADJ_EDITOR_GROSS_PREMIUM_CHANGE =
  "PREM_ADJ_EDITOR_GROSS_PREMIUM_CHANGE";
export const PREM_ADJ_EDITOR_SHARE_OF_GROSS_PREMIUM_CHANGE =
  "PREM_ADJ_EDITOR_SHARE_OF_GROSS_PREMIUM_CHANGE";
export const PREM_ADJ_EDITOR_PAYMENT_TERMS_DAYS =
  "PREM_ADJ_EDITOR_PAYMENT_TERMS_DAYS";
export const PREM_ADJ_EDITOR_PAYMENT_TERMS_DATE =
  "PREM_ADJ_EDITOR_PAYMENT_TERMS_DATE";
export const PREM_ADJ_EDITOR_BROKER = "PREM_ADJ_EDITOR_BROKER";
export const PREM_ADJ_EDITOR_COMMENTS = "PREM_ADJ_EDITOR_COMMENTS";
export const PREM_ADJ_ADD_ADJUSTMENT = "PREM_ADJ_ADD_ADJUSTMENT";
export const TEMPLATES_SUMMARISE_TEMPLATE_LABEL =
  "TEMPLATES_SUMMARISE_TEMPLATE_LABEL";
export const TEMPLATES_SUMMARY_CLOSE_LABEL = "TEMPLATES_SUMMARY_CLOSE_LABEL";
export const TEMPLATES_ERROR_LABEL = "TEMPLATES_ERROR_LABEL";
export const TEMPLATES_SUMMARY_TITLE_LABEL = "TEMPLATES_SUMMARY_TITLE_LABEL";
export const TEMPLATES_SUMMARY_NAME_HEAD_LABEL =
  "TEMPLATES_SUMMARY_NAME_HEAD_LABEL";
export const TEMPLATES_SUMMARY_VALUE_HEAD_LABEL =
  "TEMPLATES_SUMMARY_VALUE_HEAD_LABEL";
export const TEMPLATES_DOWNLOAD_TEMPLATE_LABEL =
  "TEMPLATES_DOWNLOAD_TEMPLATE_LABEL";
export const TEMPLATES_DOWNLOAD_TEMPLATE_DESCRIPTION =
  "TEMPLATES_DOWNLOAD_TEMPLATE_DESCRIPTION";
export const TEMPLATES_DOWNLOAD_FILLED_TEMPLATE_LABEL =
  "TEMPLATES_DOWNLOAD_FILLED_TEMPLATE_LABEL";
export const TEMPLATES_DOWNLOAD_FILLED_TEMPLATE_DESCRIPTION =
  "TEMPLATES_DOWNLOAD_FILLED_TEMPLATE_DESCRIPTION";
export const TEMPLATES_DOWNLOAD_FILLED_WORD_DOCUMENT_LABEL =
  "TEMPLATES_DOWNLOAD_FILLED_WORD_DOCUMENT_LABEL";
export const TEMPLATES_DOWNLOAD_FILLED_WORD_DOCUMENT_DESCRIPTION =
  "TEMPLATES_DOWNLOAD_FILLED_WORD_DOCUMENT_DESCRIPTION";
export const TEMPLATES_OVERRIDE_TEMPLATE_LABEL =
  "TEMPLATES_OVERRIDE_TEMPLATE_LABEL";
export const TEMPLATES_OVERRIDE_TEMPLATE_DESCRIPTION =
  "TEMPLATES_OVERRIDE_TEMPLATE_DESCRIPTION";

export const SOV_GRID_COPY_TO_ALL_LABEL = "SOV_GRID_COPY_TO_ALL_LABEL";
export const SOV_GRID_COPY_TO_BLANK_LABEL = "SOV_GRID_COPY_TO_BLANK_LABEL";
export const SOV_GRID_COPY_TO_FILTERED_LABEL =
  "SOV_GRID_COPY_TO_FILTERED_LABEL";

export const CAT_EXPOSURES_DESCRIPTION_COLUMN =
  "CAT_EXPOSURES_DESCRIPTION_COLUMN";
export const CAT_EXPOSURES_REGION_PERIL_COLUMN =
  "CAT_EXPOSURES_REGION_PERIL_COLUMN";
export const CAT_EXPOSURES_SUBLIMIT_COLUMN = "CAT_EXPOSURES_SUBLIMIT_COLUMN";
export const CAT_EXPOSURES_VALUE_COLUMN = "CAT_EXPOSURES_VALUE_COLUMN";
export const CAT_EXPOSURES_EXPIRING_VALUE_COLUMN =
  "CAT_EXPOSURES_EXPIRING_VALUE_COLUMN";
export const CAT_EXPOSURES_SUBLIMIT_ZONE_COLUMN =
  "CAT_EXPOSURES_SUBLIMIT_ZONE_COLUMN";
export const CAT_EXPOSURES_CAT_HAZARD_COLUMN =
  "CAT_EXPOSURES_CAT_HAZARD_COLUMN";
export const CAT_EXPOSURES_RISK_MANAGEMENT_COLUMN =
  "CAT_EXPOSURES_RISK_MANAGEMENT_COLUMN";
export const CAT_EXPOSURES_EXPOSURE_RATE_COLUMN =
  "CAT_EXPOSURES_EXPOSURE_RATE_COLUMN";
export const CAT_EXPOSURES_ADJUSTED_EXPOSURE_RATE_COLUMN =
  "CAT_EXPOSURES_ADJUSTED_EXPOSURE_RATE_COLUMN";
export const CAT_EXPOSURES_TOTAL_VALUE_COLUMN =
  "CAT_EXPOSURES_TOTAL_VALUE_COLUMN";
export const CAT_EXPOSURES_FGU_PREMIUM_COLUMN =
  "CAT_EXPOSURES_FGU_PREMIUM_COLUMN";

export const COLUMNS_BUTTON_COLUMNS = "COLUMNS_BUTTON_COLUMNS";
export const COLUMNS_BUTTON_SAVE = "COLUMNS_BUTTON_SAVE";
export const COLUMNS_BUTTON_CANCEL = "COLUMNS_BUTTON_CANCEL";
export const COLUMNS_BUTTON_SEARCH_PLACEHOLDER =
  "COLUMNS_BUTTON_SEARCH_PLACEHOLDER";
export const COLUMNS_BUTTON_EMPTY_MESSAGE = "COLUMNS_BUTTON_EMPTY_MESSAGE";

export const FILTERS_BUTTON_FILTERS = "FILTERS_BUTTON_FILTERS";
export const FILTERS_BUTTON_ACTIVE_FILTERS = "FILTERS_BUTTON_ACTIVE_FILTERS";
export const FILTERS_BUTTON_NO_ACTIVE_FILTERS =
  "FILTERS_BUTTON_NO_ACTIVE_FILTERS";
export const FILTERS_BUTTON_ADD_FILTER = "FILTERS_BUTTON_ADD_FILTER";
export const FILTERS_BUTTON_SEARCH_PLACEHOLDER =
  "FILTERS_BUTTON_SEARCH_PLACEHOLDER";
export const FILTERS_BUTTON_SELECT_COLUMN = "FILTERS_BUTTON_SELECT_COLUMN";
export const FILTERS_BUTTON_EMPTY_MESSAGE = "FILTERS_BUTTON_EMPTY_MESSAGE";
export const SEARCHABLE_LIST_SEARCH_PLACEHOLDER =
  "SEARCHABLE_LIST_SEARCH_PLACEHOLDER";
export const SEARCHABLE_LIST_EMPTY_MESSAGE = "SEARCHABLE_LIST_EMPTY_MESSAGE";
export const SEARCHABLE_LIST_LOADING = "SEARCHABLE_LIST_LOADING";
export const SEARCHABLE_LIST_PREV_PAGE = "SEARCHABLE_LIST_PREV_PAGE";
export const SEARCHABLE_LIST_NEXT_PAGE = "SEARCHABLE_LIST_NEXT_PAGE";
export const SEARCHABLE_LIST_BACK = "SEARCHABLE_LIST_BACK";
export const PAGINATION_PREVIOUS_PAGE = "PAGINATION_PREVIOUS_PAGE";
export const PAGINATION_NEXT_PAGE = "PAGINATION_NEXT_PAGE";
export const REPORTS_V3_FILTER_KIND_INPUT = "REPORTS_V3_FILTER_KIND_INPUT";
export const REPORTS_V3_FILTER_KIND_OUTPUT = "REPORTS_V3_FILTER_KIND_OUTPUT";
export const REPORTS_V3_FILTER_KIND_ROWS = "REPORTS_V3_FILTER_KIND_ROWS";
export const REPORTS_V3_FILTER_KIND_GROUPS = "REPORTS_V3_FILTER_KIND_GROUPS";
export const REPORTS_V3_FILTER_KIND_PLAIN = "REPORTS_V3_FILTER_KIND_PLAIN";
export const REPORTS_V3_BLANK_GROUP = "REPORTS_V3_BLANK_GROUP";

export const METRICS_BUTTON_METRICS = "METRICS_BUTTON_METRICS";
export const REVIEW_SCORECARD_TITLE = "REVIEW_SCORECARD_TITLE";
export const METRICS_BUTTON_SUBMISSIONS = "METRICS_BUTTON_SUBMISSIONS";
export const METRICS_BUTTON_LAYERS = "METRICS_BUTTON_LAYERS";
export const METRICS_BUTTON_STATUS = "METRICS_BUTTON_STATUS";

export const SAVE_DROPDOWN_SAVE = "SAVE_DROPDOWN_SAVE";
export const SAVE_DROPDOWN_UNSAVED_CHANGES = "SAVE_DROPDOWN_UNSAVED_CHANGES";
export const SAVE_DROPDOWN_VIEW_DETAILS = "SAVE_DROPDOWN_VIEW_DETAILS";
export const SAVE_DROPDOWN_REVERT_THIS_CHANGE =
  "SAVE_DROPDOWN_REVERT_THIS_CHANGE";
export const SAVE_DROPDOWN_SAVE_THIS_CHANGE = "SAVE_DROPDOWN_SAVE_THIS_CHANGE";
export const SAVE_DROPDOWN_REVERTED_CHANGES = "SAVE_DROPDOWN_REVERTED_CHANGES";
export const SAVE_DROPDOWN_REVERT_ALL = "SAVE_DROPDOWN_REVERT_ALL";
export const SAVE_DROPDOWN_SAVE_ALL = "SAVE_DROPDOWN_SAVE_ALL";
export const SAVE_DROPDOWN_SAVE_AS = "SAVE_DROPDOWN_SAVE_AS";

export const VIEW_MODE_TOGGLE_VIEW = "VIEW_MODE_TOGGLE_VIEW";
export const VIEW_MODE_TOGGLE_IN_PAGE = "VIEW_MODE_TOGGLE_IN_PAGE";
export const VIEW_MODE_TOGGLE_FULL_PAGE = "VIEW_MODE_TOGGLE_FULL_PAGE";
export const VIEW_MODE_TOGGLE_FULLSCREEN = "VIEW_MODE_TOGGLE_FULLSCREEN";

export const REPORT_RESULTS_SEARCH_PLACEHOLDER =
  "REPORT_RESULTS_SEARCH_PLACEHOLDER";
export const REPORT_RESULTS_EMPTY_STATE = "REPORT_RESULTS_EMPTY_STATE";
export const REPORT_RESULTS_SAVE_AS_TITLE = "REPORT_RESULTS_SAVE_AS_TITLE";
export const REPORT_RESULTS_SAVE_AS_BUTTON = "REPORT_RESULTS_SAVE_AS_BUTTON";
export const REPORT_RESULTS_SAVE_AS_SAVING = "REPORT_RESULTS_SAVE_AS_SAVING";
export const REPORT_RESULTS_COLUMN_FALLBACK = "REPORT_RESULTS_COLUMN_FALLBACK";

export const CHANGE_DETAILS_SAVED = "CHANGE_DETAILS_SAVED";
export const CHANGE_DETAILS_CURRENT = "CHANGE_DETAILS_CURRENT";
export const CHANGE_DETAILS_REVERTED = "CHANGE_DETAILS_REVERTED";
export const CHANGE_DETAILS_REVERT = "CHANGE_DETAILS_REVERT";
export const CHANGE_DETAILS_SAVE = "CHANGE_DETAILS_SAVE";
export const CHANGE_DETAILS_FORGET = "CHANGE_DETAILS_FORGET";
export const CHANGE_DETAILS_RESTORE = "CHANGE_DETAILS_RESTORE";

export const CLEARABLE_SEARCH_FIELD_CLEAR_TOOLTIP =
  "CLEARABLE_SEARCH_FIELD_CLEAR_TOOLTIP";

export const COLUMN_HEADER_MENU_SORT_ASCENDING =
  "COLUMN_HEADER_MENU_SORT_ASCENDING";
export const COLUMN_HEADER_MENU_SORT_DESCENDING =
  "COLUMN_HEADER_MENU_SORT_DESCENDING";
export const COLUMN_HEADER_MENU_CLEAR_SORTING =
  "COLUMN_HEADER_MENU_CLEAR_SORTING";
export const COLUMN_HEADER_MENU_FILTER = "COLUMN_HEADER_MENU_FILTER";
export const COLUMN_HEADER_MENU_RENAME = "COLUMN_HEADER_MENU_RENAME";
export const RENAME_DIALOG_TITLE = "RENAME_DIALOG_TITLE";
export const RENAME_DIALOG_COLUMN_NAME = "RENAME_DIALOG_COLUMN_NAME";
export const RENAME_DIALOG_REMOVE = "RENAME_DIALOG_REMOVE";
export const RENAME_DIALOG_CANCEL = "RENAME_DIALOG_CANCEL";
export const RENAME_DIALOG_CONFIRM = "RENAME_DIALOG_CONFIRM";

export const CONFIRM_DIALOG_CONFIRM = "CONFIRM_DIALOG_CONFIRM";
export const CONFIRM_DIALOG_CANCEL = "CONFIRM_DIALOG_CANCEL";

export const ADD_AGGREGATE_DIALOG_TITLE = "ADD_AGGREGATE_DIALOG_TITLE";
export const ADD_AGGREGATE_DIALOG_COLUMN_NAME =
  "ADD_AGGREGATE_DIALOG_COLUMN_NAME";
export const ADD_AGGREGATE_DIALOG_NAME_TAKEN =
  "ADD_AGGREGATE_DIALOG_NAME_TAKEN";
export const ADD_AGGREGATE_DIALOG_DELETE = "ADD_AGGREGATE_DIALOG_DELETE";
export const ADD_AGGREGATE_DIALOG_CANCEL = "ADD_AGGREGATE_DIALOG_CANCEL";
export const ADD_AGGREGATE_DIALOG_SAVE = "ADD_AGGREGATE_DIALOG_SAVE";

export const COLUMN_HEADER_MENU_PIN = "COLUMN_HEADER_MENU_PIN";
export const COLUMN_HEADER_MENU_UNPIN = "COLUMN_HEADER_MENU_UNPIN";
export const COLUMN_HEADER_MENU_REMOVE = "COLUMN_HEADER_MENU_REMOVE";
export const COLUMN_HEADER_MENU_ADD_TO_METRICS =
  "COLUMN_HEADER_MENU_ADD_TO_METRICS";
export const COLUMN_HEADER_MENU_REMOVE_FROM_METRICS =
  "COLUMN_HEADER_MENU_REMOVE_FROM_METRICS";
export const COLUMN_HEADER_MENU_GROUP_BY = "COLUMN_HEADER_MENU_GROUP_BY";
export const COLUMN_HEADER_MENU_UNGROUP = "COLUMN_HEADER_MENU_UNGROUP";
export const COLUMN_HEADER_MENU_SUMMARY_TOTAL =
  "COLUMN_HEADER_MENU_SUMMARY_TOTAL";
export const SUMMARY_TOTAL_CLEAR = "SUMMARY_TOTAL_CLEAR";
export const SUMMARY_TOTAL_TEXT_PLACEHOLDER = "SUMMARY_TOTAL_TEXT_PLACEHOLDER";
export const SUMMARY_TYPE_TOP = "SUMMARY_TYPE_TOP";
export const SUMMARY_TYPE_BOTTOM = "SUMMARY_TYPE_BOTTOM";
export const SUMMARY_TYPE_OFF = "SUMMARY_TYPE_OFF";
export const HEADER_GROUP_BY_INDICATOR = "HEADER_GROUP_BY_INDICATOR";
export const HEADER_GROUP_BY_ADD_FUNCTION_COLUMN =
  "HEADER_GROUP_BY_ADD_FUNCTION_COLUMN";
export const HEADER_INCLUDE_ALL_ENUM_VALUES = "HEADER_INCLUDE_ALL_ENUM_VALUES";
export const REPORT_RESULTS_RUN_BUTTON = "REPORT_RESULTS_RUN_BUTTON";
export const CHANGE_DETECTOR_GROUP_BY = "CHANGE_DETECTOR_GROUP_BY";
export const CHANGE_DETECTOR_GROUP_BY_ALL_UNGROUPED =
  "CHANGE_DETECTOR_GROUP_BY_ALL_UNGROUPED";
export const CHANGE_DETECTOR_GROUP_BY_COLUMNS_GROUPED =
  "CHANGE_DETECTOR_GROUP_BY_COLUMNS_GROUPED";
export const CHANGE_DETECTOR_GROUP_BY_AGGREGATION_CHANGED =
  "CHANGE_DETECTOR_GROUP_BY_AGGREGATION_CHANGED";
export const CHANGE_DETECTOR_GROUP_BY_DERIVED_COLUMNS_CHANGED =
  "CHANGE_DETECTOR_GROUP_BY_DERIVED_COLUMNS_CHANGED";
export const ADD_AGGREGATE_COLUMN_DIALOG_TITLE =
  "ADD_AGGREGATE_COLUMN_DIALOG_TITLE";
export const ADD_AGGREGATE_COLUMN_DIALOG_SAVE =
  "ADD_AGGREGATE_COLUMN_DIALOG_SAVE";
export const ADD_AGGREGATE_COLUMN_DIALOG_CANCEL =
  "ADD_AGGREGATE_COLUMN_DIALOG_CANCEL";
export const ADD_AGGREGATE_COLUMN_DELETE = "ADD_AGGREGATE_COLUMN_DELETE";
export const ADD_AGGREGATE_COLUMN_ADD = "ADD_AGGREGATE_COLUMN_ADD";
export const RANGE_GROUPING_COLUMN_DISPLAY_NAME =
  "RANGE_GROUPING_COLUMN_DISPLAY_NAME";
export const RANGE_GROUPING_DIALOG_TITLE = "RANGE_GROUPING_DIALOG_TITLE";
export const RANGE_GROUPING_DIALOG_ERROR_NOT_A_NUMBER =
  "RANGE_GROUPING_DIALOG_ERROR_NOT_A_NUMBER";
export const RANGE_GROUPING_DIALOG_ERROR_NOT_ASCENDING =
  "RANGE_GROUPING_DIALOG_ERROR_NOT_ASCENDING";
export const RANGE_GROUPING_DIALOG_SAVE = "RANGE_GROUPING_DIALOG_SAVE";
export const RANGE_GROUPING_DIALOG_CLEAR = "RANGE_GROUPING_DIALOG_CLEAR";
export const RANGE_GROUPING_DIALOG_CANCEL = "RANGE_GROUPING_DIALOG_CANCEL";
export const RANGE_GROUPING_DIALOG_DELETE_ROW =
  "RANGE_GROUPING_DIALOG_DELETE_ROW";
export const RANGE_GROUPING_DIALOG_INSERT_ROW =
  "RANGE_GROUPING_DIALOG_INSERT_ROW";
export const RANGE_GROUPING_LABEL_AND_ABOVE = "RANGE_GROUPING_LABEL_AND_ABOVE";
export const RANGE_GROUPING_LABEL_NO_VALUE = "RANGE_GROUPING_LABEL_NO_VALUE";
export const RANGE_GROUPING_LABEL_LESS_THAN = "RANGE_GROUPING_LABEL_LESS_THAN";
export const RANGE_GROUPING_LABEL_FROM_LESS_THAN =
  "RANGE_GROUPING_LABEL_FROM_LESS_THAN";
export const RANGE_GROUPING_DIALOG_UP_TO = "RANGE_GROUPING_DIALOG_UP_TO";
export const RANGE_GROUPING_DIALOG_LABEL_LINE =
  "RANGE_GROUPING_DIALOG_LABEL_LINE";
export const RANGE_GROUPING_DIALOG_EDIT_LABEL =
  "RANGE_GROUPING_DIALOG_EDIT_LABEL";
export const RANGE_GROUPING_DIALOG_NO_VALUE_TEXT =
  "RANGE_GROUPING_DIALOG_NO_VALUE_TEXT";
export const RANGE_GROUPING_DIALOG_EDIT_NO_VALUE_LABEL =
  "RANGE_GROUPING_DIALOG_EDIT_NO_VALUE_LABEL";
export const RANGE_GROUPING_DIALOG_NULL_TARGET =
  "RANGE_GROUPING_DIALOG_NULL_TARGET";
export const COLUMN_HEADER_MENU_RANGE_GROUPING_EDIT =
  "COLUMN_HEADER_MENU_RANGE_GROUPING_EDIT";
export const COLUMN_HEADER_MENU_RANGE_GROUPING_GROUP =
  "COLUMN_HEADER_MENU_RANGE_GROUPING_GROUP";
export const COLUMN_HEADER_MENU_RANGE_GROUPING_RANGES =
  "COLUMN_HEADER_MENU_RANGE_GROUPING_RANGES";
export const COLUMN_HEADER_MENU_RANGE_GROUPING_MATCHES =
  "COLUMN_HEADER_MENU_RANGE_GROUPING_MATCHES";
export const RANGE_GROUPING_DIALOG_ERROR_NOT_A_DATE =
  "RANGE_GROUPING_DIALOG_ERROR_NOT_A_DATE";
export const RANGE_GROUPING_LABEL_MATCHES = "RANGE_GROUPING_LABEL_MATCHES";
export const RANGE_GROUPING_LABEL_THE_REST = "RANGE_GROUPING_LABEL_THE_REST";
export const RANGE_GROUPING_DIALOG_OTHERWISE_MATCHES =
  "RANGE_GROUPING_DIALOG_OTHERWISE_MATCHES";
export const RANGE_GROUPING_MATCH_HELP_INTRO =
  "RANGE_GROUPING_MATCH_HELP_INTRO";
export const RANGE_GROUPING_MATCH_HELP_ANY_CHARACTERS =
  "RANGE_GROUPING_MATCH_HELP_ANY_CHARACTERS";
export const RANGE_GROUPING_MATCH_HELP_SINGLE_CHARACTER =
  "RANGE_GROUPING_MATCH_HELP_SINGLE_CHARACTER";
export const RANGE_GROUPING_MATCH_HELP_START_ANCHOR =
  "RANGE_GROUPING_MATCH_HELP_START_ANCHOR";

export const COLUMNS_SELECTOR_LOADING = "COLUMNS_SELECTOR_LOADING";
export const COLUMNS_SELECTOR_SELECT_COLUMNS =
  "COLUMNS_SELECTOR_SELECT_COLUMNS";
export const COLUMNS_SELECTOR_ADD_ALL = "COLUMNS_SELECTOR_ADD_ALL";
export const COLUMNS_SELECTOR_SEARCH_AVAILABLE =
  "COLUMNS_SELECTOR_SEARCH_AVAILABLE";
export const COLUMNS_SELECTOR_ALL_ADDED = "COLUMNS_SELECTOR_ALL_ADDED";
export const COLUMNS_SELECTOR_NO_MATCH = "COLUMNS_SELECTOR_NO_MATCH";
export const COLUMNS_SELECTOR_CLICK_TO_ADD = "COLUMNS_SELECTOR_CLICK_TO_ADD";
export const COLUMNS_SELECTOR_REPORT_COLUMNS =
  "COLUMNS_SELECTOR_REPORT_COLUMNS";
export const COLUMNS_SELECTOR_CLEAR_ALL = "COLUMNS_SELECTOR_CLEAR_ALL";
export const COLUMNS_SELECTOR_SEARCH_OUTPUT = "COLUMNS_SELECTOR_SEARCH_OUTPUT";
export const COLUMNS_SELECTOR_DROP_HERE = "COLUMNS_SELECTOR_DROP_HERE";
export const COLUMNS_SELECTOR_DROP_TO_REMOVE =
  "COLUMNS_SELECTOR_DROP_TO_REMOVE";
export const COLUMNS_SELECTOR_CLICK_TO_REMOVE =
  "COLUMNS_SELECTOR_CLICK_TO_REMOVE";
export const COLUMNS_SELECTOR_INCLUDE_IN_EXCEL =
  "COLUMNS_SELECTOR_INCLUDE_IN_EXCEL";
export const COLUMNS_SELECTOR_GROUP_AGG_DELETE_TITLE =
  "COLUMNS_SELECTOR_GROUP_AGG_DELETE_TITLE";
export const COLUMNS_SELECTOR_GROUP_AGG_DELETE_BODY =
  "COLUMNS_SELECTOR_GROUP_AGG_DELETE_BODY";
export const COLUMNS_SELECTOR_GROUP_AGG_DELETE_CONFIRM =
  "COLUMNS_SELECTOR_GROUP_AGG_DELETE_CONFIRM";

export const JOIN_EDITOR_NAME = "JOIN_EDITOR_NAME";
export const JOIN_EDITOR_LEFT = "JOIN_EDITOR_LEFT";
export const JOIN_EDITOR_RIGHT = "JOIN_EDITOR_RIGHT";
export const JOIN_EDITOR_TABLE = "JOIN_EDITOR_TABLE";
export const JOIN_EDITOR_JOIN = "JOIN_EDITOR_JOIN";
export const JOIN_EDITOR_TABLES_HEADER = "JOIN_EDITOR_TABLES_HEADER";
export const JOIN_EDITOR_JOINS_HEADER = "JOIN_EDITOR_JOINS_HEADER";
export const JOIN_EDITOR_COLUMN = "JOIN_EDITOR_COLUMN";
export const JOIN_EDITOR_ADD = "JOIN_EDITOR_ADD";
export const JOIN_EDITOR_CANCEL = "JOIN_EDITOR_CANCEL";
export const JOIN_EDITOR_ACCEPT = "JOIN_EDITOR_ACCEPT";
export const JOIN_EDITOR_NEEDS_TABLES = "JOIN_EDITOR_NEEDS_TABLES";
export const JOIN_EDITOR_NEEDS_COLUMN_PAIR = "JOIN_EDITOR_NEEDS_COLUMN_PAIR";
export const JOIN_EDITOR_NAME_NOT_UNIQUE = "JOIN_EDITOR_NAME_NOT_UNIQUE";
export const JOIN_EDITOR_NAME_BLANK = "JOIN_EDITOR_NAME_BLANK";

export const JOINS_PANEL_JOINS = "JOINS_PANEL_JOINS";
export const JOINS_PANEL_ADD_JOIN = "JOINS_PANEL_ADD_JOIN";
export const JOINS_PANEL_PAIRS = "JOINS_PANEL_PAIRS";
export const JOINS_PANEL_REMOVE_JOIN = "JOINS_PANEL_REMOVE_JOIN";

export const NAME_DIALOG_DELETE_REPORT = "NAME_DIALOG_DELETE_REPORT";
export const NAME_DIALOG_DELETE_CONFIRM_MESSAGE =
  "NAME_DIALOG_DELETE_CONFIRM_MESSAGE";
export const NAME_DIALOG_DELETE = "NAME_DIALOG_DELETE";
export const NAME_DIALOG_SHARING_AND_DELETE = "NAME_DIALOG_SHARING_AND_DELETE";
export const NAME_DIALOG_CLOSE = "NAME_DIALOG_CLOSE";
export const NAME_DIALOG_REPORT_NAME = "NAME_DIALOG_REPORT_NAME";
export const NAME_DIALOG_DESCRIPTION = "NAME_DIALOG_DESCRIPTION";
export const NAME_DIALOG_DESCRIPTION_PLACEHOLDER =
  "NAME_DIALOG_DESCRIPTION_PLACEHOLDER";
export const NAME_DIALOG_SHARE = "NAME_DIALOG_SHARE";
export const NAME_DIALOG_SHARE_DESCRIPTION = "NAME_DIALOG_SHARE_DESCRIPTION";
export const NAME_DIALOG_SHARE_ALL_USERS = "NAME_DIALOG_SHARE_ALL_USERS";
export const NAME_DIALOG_SHARE_READ_ONLY = "NAME_DIALOG_SHARE_READ_ONLY";
export const NAME_DIALOG_APPLY_SHARE = "NAME_DIALOG_APPLY_SHARE";
export const NAME_DIALOG_SHARE_FAILED = "NAME_DIALOG_SHARE_FAILED";
export const NAME_DIALOG_EDIT = "NAME_DIALOG_EDIT";
export const NAME_DIALOG_CANCEL = "NAME_DIALOG_CANCEL";

export const OPTION_FILTER_SAVE = "OPTION_FILTER_SAVE";
export const OPTION_FILTER_CANCEL = "OPTION_FILTER_CANCEL";
export const OPTION_FILTER_NO_VALUES = "OPTION_FILTER_NO_VALUES";
export const OPTION_FILTER_VALUES_UNAVAILABLE =
  "OPTION_FILTER_VALUES_UNAVAILABLE";
export const OPTION_FILTER_OPTIONS = "OPTION_FILTER_OPTIONS";

export const NUMBER_FILTER_MIN = "NUMBER_FILTER_MIN";
export const NUMBER_FILTER_MAX = "NUMBER_FILTER_MAX";
export const NUMBER_FILTER_SAVE = "NUMBER_FILTER_SAVE";
export const NUMBER_FILTER_CANCEL = "NUMBER_FILTER_CANCEL";
export const EXPRESSION_EDITOR_LITERAL_SAVE = "EXPRESSION_EDITOR_LITERAL_SAVE";
export const EXPRESSION_EDITOR_LITERAL_CANCEL =
  "EXPRESSION_EDITOR_LITERAL_CANCEL";
export const NUMBER_FILTER_CHIP_MIN = "NUMBER_FILTER_CHIP_MIN";
export const NUMBER_FILTER_CHIP_MAX = "NUMBER_FILTER_CHIP_MAX";

export const DATE_FILTER_SAVE = "DATE_FILTER_SAVE";
export const DATE_FILTER_CANCEL = "DATE_FILTER_CANCEL";
export const DATE_FILTER_FROM = "DATE_FILTER_FROM";
export const DATE_FILTER_TO = "DATE_FILTER_TO";
export const DATE_FILTER_CHIP_FROM = "DATE_FILTER_CHIP_FROM";
export const DATE_FILTER_CHIP_TO = "DATE_FILTER_CHIP_TO";

export const REPORTS_V3_TREAT_TODAY_AS_LABEL =
  "REPORTS_V3_TREAT_TODAY_AS_LABEL";
export const REPORTS_V3_TREAT_TODAY_AS_HELP = "REPORTS_V3_TREAT_TODAY_AS_HELP";
export const REPORTS_V3_TREAT_TODAY_AS_INVALID =
  "REPORTS_V3_TREAT_TODAY_AS_INVALID";
export const REPORT_RESULTS_TREAT_TODAY_AS_DISPLAY =
  "REPORT_RESULTS_TREAT_TODAY_AS_DISPLAY";
export const REPORTS_V3_LIST_LOAD_FAILED = "REPORTS_V3_LIST_LOAD_FAILED";
export const REPORTS_V3_LIST_RETRY = "REPORTS_V3_LIST_RETRY";
export const REPORTS_V3_RUN_RELATIVE_TO_LABEL =
  "REPORTS_V3_RUN_RELATIVE_TO_LABEL";
export const REPORT_RESULTS_RUN_RELATIVE_TO_DISPLAY =
  "REPORT_RESULTS_RUN_RELATIVE_TO_DISPLAY";
export const REPORTS_V3_DATE_FILTER_DYNAMIC_HEADING =
  "REPORTS_V3_DATE_FILTER_DYNAMIC_HEADING";
export const REPORTS_V3_DATE_FILTER_STATIC_HEADING =
  "REPORTS_V3_DATE_FILTER_STATIC_HEADING";
export const REPORTS_V3_DATE_FILTER_ROW_LAST =
  "REPORTS_V3_DATE_FILTER_ROW_LAST";
export const REPORTS_V3_DATE_FILTER_ROW_THIS =
  "REPORTS_V3_DATE_FILTER_ROW_THIS";
export const REPORTS_V3_DATE_FILTER_ROW_NEXT =
  "REPORTS_V3_DATE_FILTER_ROW_NEXT";
export const REPORTS_V3_DATE_FILTER_ROW_TO_DATE =
  "REPORTS_V3_DATE_FILTER_ROW_TO_DATE";
export const REPORTS_V3_DATE_FILTER_CHIP_7_DAYS =
  "REPORTS_V3_DATE_FILTER_CHIP_7_DAYS";
export const REPORTS_V3_DATE_FILTER_CHIP_30_DAYS =
  "REPORTS_V3_DATE_FILTER_CHIP_30_DAYS";
export const REPORTS_V3_DATE_FILTER_CHIP_90_DAYS =
  "REPORTS_V3_DATE_FILTER_CHIP_90_DAYS";
export const REPORTS_V3_DATE_FILTER_CHIP_WEEK =
  "REPORTS_V3_DATE_FILTER_CHIP_WEEK";
export const REPORTS_V3_DATE_FILTER_CHIP_MONTH =
  "REPORTS_V3_DATE_FILTER_CHIP_MONTH";
export const REPORTS_V3_DATE_FILTER_CHIP_QUARTER =
  "REPORTS_V3_DATE_FILTER_CHIP_QUARTER";
export const REPORTS_V3_DATE_FILTER_CHIP_YEAR =
  "REPORTS_V3_DATE_FILTER_CHIP_YEAR";
export const REPORTS_V3_DYNAMIC_DATE_LAST_7 = "REPORTS_V3_DYNAMIC_DATE_LAST_7";
export const REPORTS_V3_DYNAMIC_DATE_LAST_30 =
  "REPORTS_V3_DYNAMIC_DATE_LAST_30";
export const REPORTS_V3_DYNAMIC_DATE_LAST_90 =
  "REPORTS_V3_DYNAMIC_DATE_LAST_90";
export const REPORTS_V3_DYNAMIC_DATE_LAST_WEEK =
  "REPORTS_V3_DYNAMIC_DATE_LAST_WEEK";
export const REPORTS_V3_DYNAMIC_DATE_LAST_MONTH =
  "REPORTS_V3_DYNAMIC_DATE_LAST_MONTH";
export const REPORTS_V3_DYNAMIC_DATE_LAST_QTR =
  "REPORTS_V3_DYNAMIC_DATE_LAST_QTR";
export const REPORTS_V3_DYNAMIC_DATE_LAST_YEAR =
  "REPORTS_V3_DYNAMIC_DATE_LAST_YEAR";
export const REPORTS_V3_DYNAMIC_DATE_THIS_WEEK =
  "REPORTS_V3_DYNAMIC_DATE_THIS_WEEK";
export const REPORTS_V3_DYNAMIC_DATE_THIS_MONTH =
  "REPORTS_V3_DYNAMIC_DATE_THIS_MONTH";
export const REPORTS_V3_DYNAMIC_DATE_THIS_QTR =
  "REPORTS_V3_DYNAMIC_DATE_THIS_QTR";
export const REPORTS_V3_DYNAMIC_DATE_THIS_YEAR =
  "REPORTS_V3_DYNAMIC_DATE_THIS_YEAR";
export const REPORTS_V3_DYNAMIC_DATE_NEXT_7 = "REPORTS_V3_DYNAMIC_DATE_NEXT_7";
export const REPORTS_V3_DYNAMIC_DATE_NEXT_30 =
  "REPORTS_V3_DYNAMIC_DATE_NEXT_30";
export const REPORTS_V3_DYNAMIC_DATE_NEXT_90 =
  "REPORTS_V3_DYNAMIC_DATE_NEXT_90";
export const REPORTS_V3_DYNAMIC_DATE_NEXT_WEEK =
  "REPORTS_V3_DYNAMIC_DATE_NEXT_WEEK";
export const REPORTS_V3_DYNAMIC_DATE_NEXT_MONTH =
  "REPORTS_V3_DYNAMIC_DATE_NEXT_MONTH";
export const REPORTS_V3_DYNAMIC_DATE_NEXT_QTR =
  "REPORTS_V3_DYNAMIC_DATE_NEXT_QTR";
export const REPORTS_V3_DYNAMIC_DATE_MTD = "REPORTS_V3_DYNAMIC_DATE_MTD";
export const REPORTS_V3_DYNAMIC_DATE_YTD = "REPORTS_V3_DYNAMIC_DATE_YTD";
export const REPORTS_V3_EXPRESSION_ENUM_PICKER_HEADING =
  "REPORTS_V3_EXPRESSION_ENUM_PICKER_HEADING";

export const REPORT_BUILDER_SEARCH_TABLES = "REPORT_BUILDER_SEARCH_TABLES";
export const REPORT_BUILDER_NO_TABLES = "REPORT_BUILDER_NO_TABLES";
export const REPORT_BUILDER_NO_REPORTS = "REPORT_BUILDER_NO_REPORTS";
export const REPORT_BUILDER_TABLES_DIVIDER = "REPORT_BUILDER_TABLES_DIVIDER";
export const REPORT_BUILDER_REPORTS_DIVIDER = "REPORT_BUILDER_REPORTS_DIVIDER";
export const REPORT_BUILDER_SELECTED = "REPORT_BUILDER_SELECTED";
export const REPORT_BUILDER_EDIT_REPORT = "REPORT_BUILDER_EDIT_REPORT";
export const REPORT_BUILDER_CREATE_REPORT = "REPORT_BUILDER_CREATE_REPORT";
export const REPORT_BUILDER_REPORT_NAME = "REPORT_BUILDER_REPORT_NAME";
export const REPORT_BUILDER_DESCRIPTION = "REPORT_BUILDER_DESCRIPTION";
export const REPORT_BUILDER_DATA_SOURCES = "REPORT_BUILDER_DATA_SOURCES";
export const REPORT_BUILDER_CANCEL = "REPORT_BUILDER_CANCEL";
export const REPORT_BUILDER_SAVE_REPORT = "REPORT_BUILDER_SAVE_REPORT";
export const REPORT_BUILDER_PREVIEW_TITLE = "REPORT_BUILDER_PREVIEW_TITLE";
export const REPORT_BUILDER_PREVIEW_CLOSE = "REPORT_BUILDER_PREVIEW_CLOSE";
export const REPORT_BUILDER_PREVIEW_LOADING = "REPORT_BUILDER_PREVIEW_LOADING";
export const REPORT_BUILDER_PREVIEW_ERROR = "REPORT_BUILDER_PREVIEW_ERROR";
export const REPORT_BUILDER_PREVIEW_NO_DATA = "REPORT_BUILDER_PREVIEW_NO_DATA";
export const REPORT_BUILDER_PREVIEW_TOOLTIP = "REPORT_BUILDER_PREVIEW_TOOLTIP";
export const REPORT_BUILDER_DUPLICATE_TOOLTIP =
  "REPORT_BUILDER_DUPLICATE_TOOLTIP";
export const REPORT_BUILDER_DUPLICATE_TITLE = "REPORT_BUILDER_DUPLICATE_TITLE";
export const REPORT_BUILDER_DUPLICATE_NAME = "REPORT_BUILDER_DUPLICATE_NAME";
export const REPORT_BUILDER_DUPLICATE_NAME_TAKEN =
  "REPORT_BUILDER_DUPLICATE_NAME_TAKEN";
export const REPORT_BUILDER_DUPLICATE_COLUMNS =
  "REPORT_BUILDER_DUPLICATE_COLUMNS";
export const REPORT_BUILDER_DUPLICATE_FILTER_TOOLTIP =
  "REPORT_BUILDER_DUPLICATE_FILTER_TOOLTIP";
export const REPORT_BUILDER_DUPLICATE_CANCEL =
  "REPORT_BUILDER_DUPLICATE_CANCEL";
export const REPORT_BUILDER_DUPLICATE_SAVE = "REPORT_BUILDER_DUPLICATE_SAVE";
export const REPORT_BUILDER_DUPLICATE_EDIT_TOOLTIP =
  "REPORT_BUILDER_DUPLICATE_EDIT_TOOLTIP";
export const REPORT_BUILDER_DUPLICATE_EDIT_TITLE =
  "REPORT_BUILDER_DUPLICATE_EDIT_TITLE";
export const REPORT_BUILDER_BLOCKED_NO_COLUMNS =
  "REPORT_BUILDER_BLOCKED_NO_COLUMNS";
export const REPORT_BUILDER_BLOCKED_JOINS_INCOMPLETE =
  "REPORT_BUILDER_BLOCKED_JOINS_INCOMPLETE";
export const REPORT_BUILDER_BLOCKED_NAME_MISSING =
  "REPORT_BUILDER_BLOCKED_NAME_MISSING";
export const REPORT_BUILDER_BLOCKED_NAME_NOT_UNIQUE =
  "REPORT_BUILDER_BLOCKED_NAME_NOT_UNIQUE";
export const REPORT_BUILDER_NAME_TAKEN = "REPORT_BUILDER_NAME_TAKEN";

export const REPORTS_NAV_SELECT_REPORT = "REPORTS_NAV_SELECT_REPORT";
export const REPORTS_NAV_EDIT = "REPORTS_NAV_EDIT";
export const REPORTS_NAV_DUPLICATE = "REPORTS_NAV_DUPLICATE";
export const REPORTS_NAV_IMPORT = "REPORTS_NAV_IMPORT";
export const REPORTS_NAV_EXPORT = "REPORTS_NAV_EXPORT";
export const REPORTS_NAV_CREATE = "REPORTS_NAV_CREATE";
export const REPORTS_NAV_CREATE_MULTI_TABLE = "REPORTS_NAV_CREATE_MULTI_TABLE";
export const REPORTS_NAV_ALL_USERS = "REPORTS_NAV_ALL_USERS";
export const REPORTS_NAV_READ_ONLY = "REPORTS_NAV_READ_ONLY";
export const REPORTS_CHOOSE_REPORT_TITLE = "REPORTS_CHOOSE_REPORT_TITLE";
export const REPORTS_CHOOSE_REPORT_DESCRIPTION =
  "REPORTS_CHOOSE_REPORT_DESCRIPTION";
export const REPORTS_CHOOSE_REPORT_NEW = "REPORTS_CHOOSE_REPORT_NEW";
export const REPORTS_NAV_MULTI_TABLE = "REPORTS_NAV_MULTI_TABLE";

export const CHANGE_DETECTOR_COLUMNS = "CHANGE_DETECTOR_COLUMNS";
export const CHANGE_DETECTOR_SORT_ORDER = "CHANGE_DETECTOR_SORT_ORDER";
export const CHANGE_DETECTOR_OPTION = "CHANGE_DETECTOR_OPTION";
export const CHANGE_DETECTOR_OPTIONS = "CHANGE_DETECTOR_OPTIONS";
export const CHANGE_DETECTOR_REMOVED_VALUE_FILTER =
  "CHANGE_DETECTOR_REMOVED_VALUE_FILTER";
export const CHANGE_DETECTOR_ADDED_VALUE_FILTER =
  "CHANGE_DETECTOR_ADDED_VALUE_FILTER";
export const CHANGE_DETECTOR_CHANGED_VALUE_FILTER =
  "CHANGE_DETECTOR_CHANGED_VALUE_FILTER";
export const CHANGE_DETECTOR_REMOVED_DATE_FILTER =
  "CHANGE_DETECTOR_REMOVED_DATE_FILTER";
export const CHANGE_DETECTOR_ADDED_DATE_FILTER =
  "CHANGE_DETECTOR_ADDED_DATE_FILTER";
export const CHANGE_DETECTOR_CHANGED_DATE_FILTER =
  "CHANGE_DETECTOR_CHANGED_DATE_FILTER";
export const CHANGE_DETECTOR_REMOVED_NUMBER_FILTER =
  "CHANGE_DETECTOR_REMOVED_NUMBER_FILTER";
export const CHANGE_DETECTOR_ADDED_NUMBER_FILTER =
  "CHANGE_DETECTOR_ADDED_NUMBER_FILTER";
export const CHANGE_DETECTOR_CHANGED_NUMBER_FILTER =
  "CHANGE_DETECTOR_CHANGED_NUMBER_FILTER";
export const CHANGE_DETECTOR_COLUMN_PINNED = "CHANGE_DETECTOR_COLUMN_PINNED";
export const CHANGE_DETECTOR_COLUMNS_PINNED = "CHANGE_DETECTOR_COLUMNS_PINNED";
export const CHANGE_DETECTOR_COLUMN_UNPINNED =
  "CHANGE_DETECTOR_COLUMN_UNPINNED";
export const CHANGE_DETECTOR_COLUMNS_UNPINNED =
  "CHANGE_DETECTOR_COLUMNS_UNPINNED";
export const CHANGE_DETECTOR_PINNING_CHANGED =
  "CHANGE_DETECTOR_PINNING_CHANGED";
export const CHANGE_DETECTOR_ORDER_CHANGED = "CHANGE_DETECTOR_ORDER_CHANGED";
export const CHANGE_DETECTOR_VISIBILITY_CHANGED =
  "CHANGE_DETECTOR_VISIBILITY_CHANGED";
export const CHANGE_DETECTOR_COLUMN_PREFIX = "CHANGE_DETECTOR_COLUMN_PREFIX";
export const CHANGE_DETECTOR_AND = "CHANGE_DETECTOR_AND";
export const CHANGE_DETECTOR_SORTED_BY = "CHANGE_DETECTOR_SORTED_BY";
export const CHANGE_DETECTOR_SORT_CLEARED = "CHANGE_DETECTOR_SORT_CLEARED";
export const CHANGE_DETECTOR_COLUMN_WIDTHS = "CHANGE_DETECTOR_COLUMN_WIDTHS";
export const CHANGE_DETECTOR_COLUMN_WIDTHS_CHANGED =
  "CHANGE_DETECTOR_COLUMN_WIDTHS_CHANGED";
export const CHANGE_DETAILS_WIDTH_INCREASED = "CHANGE_DETAILS_WIDTH_INCREASED";
export const CHANGE_DETAILS_WIDTH_REDUCED = "CHANGE_DETAILS_WIDTH_REDUCED";
export const CHANGE_DETAILS_WIDTH_INCREASED_SLIGHTLY =
  "CHANGE_DETAILS_WIDTH_INCREASED_SLIGHTLY";
export const CHANGE_DETAILS_WIDTH_REDUCED_SLIGHTLY =
  "CHANGE_DETAILS_WIDTH_REDUCED_SLIGHTLY";
export const CHANGE_DETAILS_RANGE_HEADING = "CHANGE_DETAILS_RANGE_HEADING";
export const CHANGE_DETAILS_RANGE_LESS_THAN = "CHANGE_DETAILS_RANGE_LESS_THAN";
export const CHANGE_DETAILS_RANGE_MATCHES = "CHANGE_DETAILS_RANGE_MATCHES";
export const CHANGE_DETAILS_RANGE_OTHERWISE = "CHANGE_DETAILS_RANGE_OTHERWISE";
export const COLUMN_HEADER_MENU_FORMAT = "COLUMN_HEADER_MENU_FORMAT";
export const COLUMN_HEADER_MENU_FORMAT_AUTO = "COLUMN_HEADER_MENU_FORMAT_AUTO";
export const CHANGE_DETECTOR_COLUMN_DECIMALS =
  "CHANGE_DETECTOR_COLUMN_DECIMALS";
export const CHANGE_DETECTOR_COLUMN_DECIMALS_CHANGED =
  "CHANGE_DETECTOR_COLUMN_DECIMALS_CHANGED";
export const CHANGE_DETECTOR_METRIC_ADDED = "CHANGE_DETECTOR_METRIC_ADDED";
export const CHANGE_DETECTOR_METRICS_ADDED = "CHANGE_DETECTOR_METRICS_ADDED";
export const CHANGE_DETECTOR_METRIC_REMOVED = "CHANGE_DETECTOR_METRIC_REMOVED";
export const CHANGE_DETECTOR_METRICS_REMOVED =
  "CHANGE_DETECTOR_METRICS_REMOVED";
export const CHANGE_DETECTOR_METRICS_CHANGED =
  "CHANGE_DETECTOR_METRICS_CHANGED";
export const CHANGE_DETECTOR_METRICS = "CHANGE_DETECTOR_METRICS";
export const CHANGE_DETECTOR_DISPLAY_NAME_RESET =
  "CHANGE_DETECTOR_DISPLAY_NAME_RESET";
export const CHANGE_DETECTOR_RENAMED_TO = "CHANGE_DETECTOR_RENAMED_TO";
export const CHANGE_DETECTOR_SEARCH_TEXT_CHANGED =
  "CHANGE_DETECTOR_SEARCH_TEXT_CHANGED";
export const CHANGE_DETECTOR_SEARCH_FILTER_ADDED =
  "CHANGE_DETECTOR_SEARCH_FILTER_ADDED";
export const CHANGE_DETECTOR_SEARCH_FILTER_REMOVED =
  "CHANGE_DETECTOR_SEARCH_FILTER_REMOVED";
export const CHANGE_DETECTOR_SEARCH = "CHANGE_DETECTOR_SEARCH";
export const CHANGE_DETECTOR_SUMMARY = "CHANGE_DETECTOR_SUMMARY";
export const CHANGE_DETECTOR_SUMMARY_ADDED = "CHANGE_DETECTOR_SUMMARY_ADDED";
export const CHANGE_DETECTOR_SUMMARY_REMOVED =
  "CHANGE_DETECTOR_SUMMARY_REMOVED";
export const CHANGE_DETECTOR_SUMMARY_CHANGED =
  "CHANGE_DETECTOR_SUMMARY_CHANGED";
export const CHANGE_DETECTOR_REVERTED = "CHANGE_DETECTOR_REVERTED";
export const NUMBER_FILTER_NO_VALUES = "NUMBER_FILTER_NO_VALUES";

export const TOWER_SIR_COPY_TO_ALL_LABEL = "TOWER_SIR_COPY_TO_ALL_LABEL";
export const TOWER_SIR_COPY_TO_EMPTY_LABEL = "TOWER_SIR_COPY_TO_EMPTY_LABEL";

export const TARGET_LOSS_RATIOS_TITLE = "TARGET_LOSS_RATIOS_TITLE";
export const TARGET_LOSS_RATIOS_MODEL = "TARGET_LOSS_RATIOS_MODEL";
export const TARGET_LOSS_RATIOS_LAYER = "TARGET_LOSS_RATIOS_LAYER";
export const TARGET_LOSS_RATIOS_LOSS_RATIO = "TARGET_LOSS_RATIOS_LOSS_RATIO";
export const TARGET_LOSS_RATIOS_EMPTY = "TARGET_LOSS_RATIOS_EMPTY";
export const RATE_ADEQUACY_TITLE = "RATE_ADEQUACY_TITLE";
export const RATE_ADEQUACY_CURRENT_YEAR = "RATE_ADEQUACY_CURRENT_YEAR";
export const RATE_ADEQUACY_PREVIOUS_YEAR = "RATE_ADEQUACY_PREVIOUS_YEAR";
export const RATE_ADEQUACY_CHANGE = "RATE_ADEQUACY_CHANGE";
export const RATE_ADEQUACY_LOSS_PICK = "RATE_ADEQUACY_LOSS_PICK";
export const RATE_ADEQUACY_EXPECTED_COMMISSION =
  "RATE_ADEQUACY_EXPECTED_COMMISSION";
export const RATE_ADEQUACY_BROKERAGE = "RATE_ADEQUACY_BROKERAGE";
export const RATE_ADEQUACY_EXPENSES = "RATE_ADEQUACY_EXPENSES";
export const RATE_ADEQUACY_COMBINED_RATIO = "RATE_ADEQUACY_COMBINED_RATIO";
export const RATE_ADEQUACY_TARGET_COMBINED_RATIO =
  "RATE_ADEQUACY_TARGET_COMBINED_RATIO";
export const RATE_ADEQUACY_ADEQUACY = "RATE_ADEQUACY_ADEQUACY";
export const RATE_ADEQUACY_RATE_CHANGE = "RATE_ADEQUACY_RATE_CHANGE";
export const RATE_ADEQUACY_NO_PRIOR = "RATE_ADEQUACY_NO_PRIOR";
export const RATE_ADEQUACY_NO_TARGET = "RATE_ADEQUACY_NO_TARGET";
